"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2366],{

/***/ 84972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_ProfileBottomView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(Text);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var useTranslation = __webpack_require__(77058);
;// CONCATENATED MODULE: ./src/modules/profile/components/profileBottomTabData.js

/* harmony default export */ var profileBottomTabData = ({
  userMenu: [{
    id: 1,
    title: "Activity",
    tabType: config/* Constants.profileTabType.TAB_ACTIVITY */.gT.profileTabType.TAB_ACTIVITY
  }, {
    id: 3,
    title: "Media",
    tabType: config/* Constants.profileTabType.TAB_MEDIA */.gT.profileTabType.TAB_MEDIA
  }],
  eventMenu: [{
    id: 1,
    title: "About",
    tabType: config/* Constants.profileTabType.TAB_ABOUT */.gT.profileTabType.TAB_ABOUT
  }, {
    id: 3,
    title: "Media",
    tabType: config/* Constants.profileTabType.TAB_MEDIA */.gT.profileTabType.TAB_MEDIA
  }, {
    id: 4,
    title: "Lineup",
    tabType: config/* Constants.profileTabType.TAB_LINEUP */.gT.profileTabType.TAB_LINEUP
  } // {
  //   id: 5,
  //   title: "Wall",
  //   tabType: Constants.profileTabType.TAB_WALL,
  // },
  // {
  //   id: 5,
  //   title: "Memories",
  //   tabType: Constants.profileTabType.TAB_MEMORIES,
  // },
  ],
  artistMenu: [{
    id: 1,
    title: "About",
    tabType: config/* Constants.profileTabType.TAB_ABOUT */.gT.profileTabType.TAB_ABOUT
  }, {
    id: 2,
    title: "Media",
    tabType: config/* Constants.profileTabType.TAB_MEDIA */.gT.profileTabType.TAB_MEDIA
  }, {
    id: 3,
    title: "Festivals",
    tabType: config/* Constants.profileTabType.TAB_EVENT */.gT.profileTabType.TAB_EVENT
  } // {
  //   id: 4,
  //   title: "Wall",
  //   tabType: Constants.profileTabType.TAB_WALL,
  // },
  // {
  //   id: 5,
  //   title: "Memories",
  //   tabType: Constants.profileTabType.TAB_MEMORIES,
  // },
  ],
  venueMenu: [{
    id: 1,
    title: "About",
    tabType: config/* Constants.profileTabType.TAB_ABOUT */.gT.profileTabType.TAB_ABOUT
  }, {
    id: 3,
    title: "Media",
    tabType: config/* Constants.profileTabType.TAB_MEDIA */.gT.profileTabType.TAB_MEDIA
  } // {
  //   id: 4,
  //   title: "Events",
  //   tabType: Constants.profileTabType.TAB_EVENT,
  // },
  // {
  //   id: 5,
  //   title: "Wall",
  //   tabType: Constants.profileTabType.TAB_WALL,
  // },
  // {
  //   id: 6,
  //   title: "Memories",
  //   tabType: Constants.profileTabType.TAB_MEMORIES,
  // },
  ]
});
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./helpers/index.js
var helpers = __webpack_require__(60651);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/atoms/CTab/index.js








var CTab = function CTab(props) {
  var tabs = props.tabs,
      selectedTabIndex = props.selectedTabIndex,
      item = props.item,
      category = props.category,
      isMobileVersion = props.isMobileVersion,
      isHeadingAbout = props.isHeadingAbout;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex flex-wrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-xs font-medium  text-center text-gray-500 dark:text-gray-400 ",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
            className: "flex sm:flex-wrap -mb-px w-full mb-3",
            children: tabs.map(function (tab, index) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                className: "flex-auto mr-0",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  prefetch: false,
                  href: (0,helpers/* generateURLSlug */.ZF)(item.id, item.title || item.displayName || item.nickname, item.startDate, category, "about#".concat(tab.tabType)),
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("a", {
                    className: "w-full relative " + (selectedTabIndex === index ? "inline-block ".concat(isMobileVersion ? "p-4" : "p-6", " w-full rounded-t-lg border-b ").concat((0,formatHelpers/* getClass */.ll)("border-gray"), " dark:text-blue-500") : "inline-block ".concat(isMobileVersion ? "p-4" : "p-6", " w-full text-blue-600 rounded-t-lg border-b ").concat((0,formatHelpers/* getClass */.ll)("border-gray"), " active dark:text-blue-500")),
                    "data-toggle": "tab",
                    onClick: function onClick(e) {
                      e.preventDefault();

                      if (props.onChangeTab) {
                        props.onChangeTab(index);
                      }
                    },
                    role: "button",
                    "aria-current": "page",
                    style: isMobileVersion ? {
                      fontSize: 12,
                      fontFamily: (0,formatHelpers/* getClass */.ll)("weight-tab-bold", false, selectedTabIndex === index),
                      color: selectedTabIndex === index ? (0,formatHelpers/* getClass */.ll)("text-white") : (0,formatHelpers/* getClass */.ll)("text-gray")
                    } : {
                      fontSize: 16,
                      height: 70,
                      fontFamily: (0,formatHelpers/* getClass */.ll)("weight-tab-bold", false, selectedTabIndex === index),
                      color: selectedTabIndex === index ? (0,formatHelpers/* getClass */.ll)("text-white") : (0,formatHelpers/* getClass */.ll)("text-gray")
                    },
                    children: [isHeadingAbout && tab.title === "About" ? /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                      children: tab.title
                    }) : tab.title, selectedTabIndex === index && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "".concat((0,formatHelpers/* getClass */.ll)("btn-gradient2")),
                      style: {
                        position: "absolute",
                        bottom: -1.5,
                        left: 0,
                        width: "100%",
                        height: 2,
                        borderRadius: 1
                      }
                    })]
                  })
                })
              }, index);
            })
          }), props.children]
        })
      })
    })
  });
};

/* harmony default export */ var atoms_CTab = (CTab);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/modules/profile/components/ProfileBottomView.js













var ProfileAbout = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 9590).then(__webpack_require__.bind(__webpack_require__, 99590));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(99590)];
    }
  }
});
var MediaListContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 100).then(__webpack_require__.bind(__webpack_require__, 100));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(100)];
    }
  }
});
var LineupContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2101).then(__webpack_require__.bind(__webpack_require__, 72101));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(72101)];
    }
  }
});
var InsightContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7359).then(__webpack_require__.bind(__webpack_require__, 47359));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(47359)];
    }
  }
});
var EventContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 215).then(__webpack_require__.bind(__webpack_require__, 215));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(215)];
    }
  }
});
var CompanyHomeScreen = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7199).then(__webpack_require__.bind(__webpack_require__, 87199));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87199)];
    }
  }
});

var ProfileBottomView = function ProfileBottomView(props) {
  var isNested = props.isNested,
      item = props.item,
      category = props.category,
      initialTabIndex = props.initialTabIndex,
      initialTabType = props.initialTabType,
      subTabType = props.subTabType,
      isAccount = props.isAccount,
      isMobileVersion = props.isMobileVersion,
      venueEvents = props.venueEvents;
  var items = [];

  if (category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT || category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
    items = profileBottomTabData.eventMenu;
  } else if (category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
    items = profileBottomTabData.artistMenu;
  } else if (category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) {
    items = (venueEvents === null || venueEvents === void 0 ? void 0 : venueEvents.length) > 0 ? profileBottomTabData.venueMenu.concat([{
      id: 4,
      title: "Events",
      tabType: config/* Constants.profileTabType.TAB_EVENT */.gT.profileTabType.TAB_EVENT
    }]) : // :
    // item?.companyHomes?.length > 0
    // ? profileBottomTabData.venueMenu.concat([
    //     {
    //       id: 4,
    //       title: "Homes",
    //       tabType: Constants.profileTabType.TAB_HOME,
    //     },
    //   ])
    profileBottomTabData.venueMenu;
  } else if (category === config/* Constants.categoryType.CATEGORY_USER */.gT.categoryType.CATEGORY_USER) {
    items = profileBottomTabData.userMenu;
  }

  var tabIndex = initialTabIndex;

  if (initialTabType) {
    tabIndex = items.findIndex(function (x) {
      return x.tabType === initialTabType;
    });
  }

  var _useState = (0,react.useState)(tabIndex || 0),
      selectedTabIndex = _useState[0],
      setSelectedTabIndex = _useState[1];

  var _useState2 = (0,react.useState)(initialTabType == undefined ? items[0].tabType : ""),
      selectedTabType = _useState2[0],
      setSelectedTabType = _useState2[1];

  var privacy = "public";

  if (item !== null && item !== void 0 && item.privacy && !isAccount) {
    privacy = item === null || item === void 0 ? void 0 : item.privacy;
  }

  (0,react.useEffect)(function () {
    changeTabType(initialTabType || "about");
  }, [initialTabType]);

  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var navigation = (0,router.useRouter)();
  if (!item) return null;

  var changeTabType = function changeTabType(tabType) {
    var index = items.findIndex(function (x) {
      return x.tabType == tabType;
    });
    setSelectedTabIndex(index);
    setSelectedTabType(tabType);
  };

  var onChangeTabType = function onChangeTabType(tabType) {
    navigation.replace({
      pathname: (0,helpers/* generateURLSlug */.ZF)(item.id, item.title || item.displayName || item.nickname, item.startDate, category, "about"),
      hash: tabType === "about" ? null : tabType
    });
    changeTabType(tabType);
  };

  var renderAbout = function renderAbout() {
    if (isNested) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileAbout, {
        item: item,
        category: category,
        changeTabType: onChangeTabType,
        isMobileVersion: isMobileVersion
      });
    } else {
      return null;
    }
  };

  var renderContent = function renderContent(tabItem) {
    if (!tabItem) return null;
    var tabType = tabItem.tabType;

    if (tabType == config/* Constants.profileTabType.TAB_ABOUT */.gT.profileTabType.TAB_ABOUT) {
      return renderAbout();
    }

    if (tabType == config/* Constants.profileTabType.TAB_INSIGHT */.gT.profileTabType.TAB_INSIGHT) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(InsightContainer, {
        item: item,
        category: category,
        tabType: selectedTabType,
        isMobileVersion: isMobileVersion
      });
    }

    if (tabType == config/* Constants.profileTabType.TAB_EVENT */.gT.profileTabType.TAB_EVENT) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(EventContainer, {
        item: item,
        category: category,
        tabType: selectedTabType,
        isMobileVersion: isMobileVersion
      });
    }

    if (tabType == config/* Constants.profileTabType.TAB_HOME */.gT.profileTabType.TAB_HOME) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyHomeScreen, {
        items: item.companyHomes,
        category: category,
        isMobileVersion: isMobileVersion
      });
    }

    if (tabType == config/* Constants.profileTabType.TAB_MEDIA */.gT.profileTabType.TAB_MEDIA) {
      return privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: {
          padding: 20,
          alignItems: "center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: {
            color: config/* Colors.grayText */.wL.grayText,
            fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
            fontSize: 16,
            lineHeight: 20
          },
          children: t("key_private_mode_text")
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(MediaListContainer, {
        item: item,
        category: category,
        profileId: item.profileId,
        tabType: selectedTabType,
        subTabType: subTabType,
        isMobileVersion: isMobileVersion
      });
    }

    if (tabType == config/* Constants.profileTabType.TAB_LINEUP */.gT.profileTabType.TAB_LINEUP) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(LineupContainer, {
        item: item,
        category: category,
        tabType: selectedTabType,
        isMobileVersion: isMobileVersion
      });
    }

    if (tabType == config/* Constants.profileTabType.TAB_WALL */.gT.profileTabType.TAB_WALL) {
      return null; // <WallContainer
      //   item={item}
      //   category={category}
      //   tabType={selectedTabType}
      //   isMobileVersion={isMobileVersion}
      // />
    }

    if (tabType == config/* Constants.profileTabType.TAB_MEMORIES */.gT.profileTabType.TAB_MEMORIES) {
      return null; // <MemoryContainer
      //   item={item}
      //   category={category}
      //   tabType={selectedTabType}
      //   isMobileVersion={isMobileVersion}
      // />
    }

    if (tabType == config/* Constants.profileTabType.TAB_ACTIVITY */.gT.profileTabType.TAB_ACTIVITY) {
      return privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: {
          padding: 20,
          alignItems: "center"
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: {
            color: config/* Colors.grayText */.wL.grayText,
            fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
            fontSize: 16,
            lineHeight: 20
          },
          children: t("key_private_mode_text")
        })
      }) : null; // <ActivityContainer
      //   item={item}
      //   category={category}
      //   tabType={selectedTabType}
      //   isMobileVersion={isMobileVersion}
      // />
    }

    return null;
  };

  var renderTabs = function renderTabs() {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "relative flex flex-col min-w-0 break-words w-full mb-1 ",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "px-0 flex-auto",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "tab-content tab-space",
          children: items.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: selectedTabType === item.tabType ? "block" : "hidden",
              id: "link" + index,
              children: renderContent(item)
            }, index);
          })
        })
      })
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [styles.container, isMobileVersion ? {
      borderTopLeftRadius: 25,
      borderTopRightRadius: 25,
      paddingBottom: 0
    } : {}, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_CTab, {
      selectedTabIndex: selectedTabIndex,
      onChangeTab: function onChangeTab(index) {
        var _items$index;

        onChangeTabType((_items$index = items[index]) === null || _items$index === void 0 ? void 0 : _items$index.tabType);
      },
      tabs: items,
      item: item,
      category: category,
      isMobileVersion: isMobileVersion,
      isHeadingAbout: true,
      children: renderTabs()
    })
  });
};

var styles = StyleSheet_default().create({
  container: {
    //alignSelf: "stretch",
    flexDirection: "column",
    paddingBottom: 25,
    backgroundColor: (0,formatHelpers/* getClass */.ll)("background"),
    overflow: "hidden"
  }
});
/* harmony default export */ var components_ProfileBottomView = (ProfileBottomView);

/***/ }),

/***/ 62219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54176);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(79057);
/* harmony import */ var react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_atoms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52738);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_swipeable__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45338);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_ubuntu_webApp_cocktayl_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var PopupMenuListModal = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94843));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94843)];
    }
  }
});

var ProfileHeader = function ProfileHeader(props) {
  var _photos, _props$event, _props$event2, _props$artist, _props$venue;

  var customNavBar = props.customNavBar,
      isShowMenu = props.isShowMenu,
      isMobileVersion = props.isMobileVersion,
      activeIndex = props.activeIndex,
      setActiveIndex = props.setActiveIndex,
      category = props.category;
  var showDefaultProfileHeader = !customNavBar;
  var handlers = (0,react_swipeable__WEBPACK_IMPORTED_MODULE_8__/* .useSwipeable */ .QS)({
    onSwipedLeft: function onSwipedLeft(eventData) {
      if (activeIndex + 1 > photos.length - 1) {
        setActiveIndex(0);
      } else {
        setActiveIndex(activeIndex + 1);
      }
    },
    onSwipedRight: function onSwipedRight(eventData) {
      if (activeIndex - 1 < 0) {
        setActiveIndex(photos.length - 1);
      } else {
        setActiveIndex(activeIndex - 1);
      }
    }
  });
  var photos = props.photos ? props.photos : [];

  if (!Array.isArray(photos)) {
    photos = JSON.parse(photos);
  }

  var onPressMenuItem = function onPressMenuItem(item) {
    if (props.onPressMenuItem) {
      props.onPressMenuItem(item);
    }

    props.onChangeIsShown(false);
  };

  var backgroundImage = ((_photos = photos) === null || _photos === void 0 ? void 0 : _photos.length) > 0 ? photos[activeIndex].url : "Local:imagePlaceholder";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((react_native_web_dist_cjs_exports_View__WEBPACK_IMPORTED_MODULE_9___default()), {
    style: [props.style],
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", _objectSpread(_objectSpread({}, handlers), {}, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .CImage */ .DW, {
        priority: true,
        objectFit: "fixed",
        imgUrl: backgroundImage,
        alt: props !== null && props !== void 0 && props.event ? "".concat(props === null || props === void 0 ? void 0 : (_props$event = props.event) === null || _props$event === void 0 ? void 0 : _props$event.title, " ").concat(moment__WEBPACK_IMPORTED_MODULE_5___default()(props === null || props === void 0 ? void 0 : (_props$event2 = props.event) === null || _props$event2 === void 0 ? void 0 : _props$event2.startDate).format("YYYY"), " ").concat(category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? "Artist" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? "Venue" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP ? "Rooftop" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA ? "Spa" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Club" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Company" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? "Home" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? "Zoo/animal park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? "Animal" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? "Park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? "Casino" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Castle" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT ? "Resort" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? "Aparthotel" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bar" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT ? "Event" : "Festival") : props !== null && props !== void 0 && props.artist ? "".concat(props === null || props === void 0 ? void 0 : (_props$artist = props.artist) === null || _props$artist === void 0 ? void 0 : _props$artist.displayName, " ").concat(category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? "Artist" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? "Venue" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP ? "Rooftop" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA ? "Spa" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Club" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Company" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? "Home" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? "Zoo/animal park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? "Animal" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? "Park" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? "Casino" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Castle" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT ? "Resort" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? "Aparthotel" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bar" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT ? "Event" : "Festival") : "".concat(props === null || props === void 0 ? void 0 : (_props$venue = props.venue) === null || _props$venue === void 0 ? void 0 : _props$venue.nickname, " ").concat(category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ARTIST */ .gT.categoryType.CATEGORY_ARTIST ? "Artist" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE */ .gT.categoryType.CATEGORY_VENUE ? "Venue" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ROOFTOP */ .gT.categoryType.CATEGORY_ROOFTOP ? "Rooftop" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_SPA */ .gT.categoryType.CATEGORY_SPA ? "Spa" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_BEACHFUL */ .gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Club" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_COMPANY */ .gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Company" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PREFAB_HOMES */ .gT.categoryType.CATEGORY_PREFAB_HOMES ? "Home" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ZOO */ .gT.categoryType.CATEGORY_ZOO ? "Zoos" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_ANIMAL */ .gT.categoryType.CATEGORY_ANIMAL ? "Animals" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_PARKFUL */ .gT.categoryType.CATEGORY_PARKFUL ? "Parks" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASINO */ .gT.categoryType.CATEGORY_CASINO ? "Casinos" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_CASTLE */ .gT.categoryType.CATEGORY_CASTLE ? "Castles" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_RESORT */ .gT.categoryType.CATEGORY_RESORT ? "Resorts" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_APARTHOTEL */ .gT.categoryType.CATEGORY_APARTHOTEL ? "Aparthotels" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_VENUE_COCKTAIL */ .gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bar" : category === _config__WEBPACK_IMPORTED_MODULE_2__/* .Constants.categoryType.CATEGORY_EVENT */ .gT.categoryType.CATEGORY_EVENT ? "Event" : "Festival")
      })
    })), showDefaultProfileHeader && isMobileVersion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_atoms__WEBPACK_IMPORTED_MODULE_3__/* .BackButton */ .xE, {}), showDefaultProfileHeader && isMobileVersion && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "flex absolute top-[16px] right-[16px] w-[30px] h-[30px] items-center justify-center bg-black10 rounded-full cursor-pointer",
      onClick: function onClick() {
        return props.onChangeIsShown(true);
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
        src: _config__WEBPACK_IMPORTED_MODULE_2__/* .Images.iconMoreWhite */ .rU.iconMoreWhite,
        width: 20,
        height: 20,
        alt: "icon more menu"
      })
    }), photos.length > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
      className: "absolute z-10 w-full flex flex-row justify-center ".concat(isMobileVersion ? "pt-[26px]" : "pt-[39px]"),
      children: photos.map(function (item, index) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
          className: "h-[6px] w-[6px] mr-[8px] rounded-full ".concat(index === activeIndex ? "bg-white" : "bg-black25"),
          children: "\xA0"
        }, index);
      })
    }), !isMobileVersion && photos.length > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)("div", {
      className: "absolute z-10 h-full w-full flex flex-row justify-between items-center px-[15px]",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          if (activeIndex - 1 < 0) {
            setActiveIndex(photos.length - 1);
          } else {
            setActiveIndex(activeIndex - 1);
          }
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("img", {
          src: "/icons/ic_arrow_left_black_40.png",
          width: "45",
          height: "45",
          alt: "arrow"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("div", {
        className: "cursor-pointer",
        onClick: function onClick() {
          if (activeIndex + 1 > photos.length - 1) {
            setActiveIndex(0);
          } else {
            setActiveIndex(activeIndex + 1);
          }
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("img", {
          src: "/icons/ic_arrow_right_black_40.png",
          width: "45",
          height: "45",
          alt: "arrow"
        })
      })]
    }), customNavBar, isShowMenu && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(PopupMenuListModal, {
      isVisible: isShowMenu,
      onClose: function onClose() {
        props.onChangeIsShown(false);
      },
      onPressItem: onPressMenuItem,
      items: props.items,
      isMobileVersion: isMobileVersion,
      category: props.category
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (ProfileHeader);

/***/ }),

/***/ 2366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ profile; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/config/index.js + 8 modules
var config = __webpack_require__(54176);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/View/index.js
var exports_View = __webpack_require__(79057);
var View_default = /*#__PURE__*/__webpack_require__.n(exports_View);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/TouchableOpacity/index.js
var exports_TouchableOpacity = __webpack_require__(28908);
var TouchableOpacity_default = /*#__PURE__*/__webpack_require__.n(exports_TouchableOpacity);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 3 modules
var es_useTranslation = __webpack_require__(77058);
// EXTERNAL MODULE: ./src/modules/profile/components/ProfileHeader.js
var ProfileHeader = __webpack_require__(62219);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Text/index.js
var exports_Text = __webpack_require__(48409);
var Text_default = /*#__PURE__*/__webpack_require__.n(exports_Text);
// EXTERNAL MODULE: ./src/modules/profile/event/components/DurationView.js
var DurationView = __webpack_require__(2010);
// EXTERNAL MODULE: ./src/components/atoms/index.js + 38 modules
var atoms = __webpack_require__(52738);
// EXTERNAL MODULE: ./src/helpers/index.js + 1 modules
var helpers = __webpack_require__(85112);
// EXTERNAL MODULE: ./src/helpers/formatHelpers.js
var formatHelpers = __webpack_require__(9465);
// EXTERNAL MODULE: ./src/components/molecules/index.js + 37 modules
var molecules = __webpack_require__(53732);
// EXTERNAL MODULE: ./src/modules/profile/event/components/EventStatusView.js
var EventStatusView = __webpack_require__(76507);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/modules/profile/modals/OfficialBadgeModal/OfficialBadgeContainer.js











var OfficialBadgeContainer = function OfficialBadgeContainer(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [styles.container, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: {
        backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1"),
        justifyContent: "center",
        alignItems: "center",
        paddingHorizontal: 22,
        marginBottom: 14,
        borderRadius: 18,
        width: "100%",
        height: "100%"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        source: config/* Images.iconVerifiedBadgeMedium */.rU.iconVerifiedBadgeMedium,
        alt: "verified account",
        width: isMobileVersion ? 24 : 35,
        height: isMobileVersion ? 24 : 35,
        layout: "fixed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: {
          fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
          fontSize: isMobileVersion ? 16 : 20,
          lineHeight: isMobileVersion ? 20 : 24,
          color: config/* Colors.white */.wL.white,
          marginVertical: isMobileVersion ? 9 : 14,
          textAlign: "center"
        },
        children: "Official Account"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
        style: {
          fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
          fontSize: isMobileVersion ? 12 : 16,
          lineHeight: isMobileVersion ? 16 : 18,
          color: config/* Colors.white80 */.wL.white80,
          textAlign: "center"
        },
        children: ["This is an official account verified by", " ", "Cocktayl"]
      })]
    })
  });
};

var styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  }
});
/* harmony default export */ var OfficialBadgeModal_OfficialBadgeContainer = (OfficialBadgeContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/OfficialBadgeModal/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var OfficialBadgeModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, _objectSpread(_objectSpread({
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(OfficialBadgeModal_OfficialBadgeContainer, _objectSpread(_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction
    }))
  }));
});
/* harmony default export */ var modals_OfficialBadgeModal = (OfficialBadgeModal);
;// CONCATENATED MODULE: ./src/modules/profile/event/components/EventInfoView.js

















var TagView = function TagView(props) {
  var isMobileVersion = props.isMobileVersion;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [EventInfoView_styles.tagContainer, props.style, {
        marginTop: 0,
        height: 20
      }],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [EventInfoView_styles.tagText, {
          fontSize: 10
        }],
        numberOfLines: 1,
        ellipsizeMode: "tail",
        children: props.title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [EventInfoView_styles.tagContainer, props.style, {
        marginTop: 0
      }],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: EventInfoView_styles.tagText,
        numberOfLines: 1,
        ellipsizeMode: "tail",
        children: props.title
      })
    })
  });
};

var EventInfoView = function EventInfoView(props) {
  var _timezoneData$label, _ref;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)(false),
      showPopupOfficial = _useState[0],
      setShowPopupOfficial = _useState[1];

  var alertModalRef = (0,react.useRef)(null);
  var officialBadgeModalRef = (0,react.useRef)(null);
  var isMobileVersion = props.isMobileVersion;
  var _props$item = props.item,
      id = _props$item.id,
      isVirtual = _props$item.isVirtual,
      isInPerson = _props$item.isInPerson,
      title = _props$item.title,
      startDate = _props$item.startDate,
      endDate = _props$item.endDate,
      totalSaved = _props$item.totalSaved,
      totalGoing = _props$item.totalGoing,
      totalConnection = _props$item.totalConnection,
      profileId = _props$item.profileId,
      isSaving = _props$item.isSaving,
      isGoing = _props$item.isGoing,
      status = _props$item.status,
      timezoneData = _props$item.timezoneData,
      isOfficial = _props$item.isOfficial,
      isPro = _props$item.isPro;
  var location = // (props.item.location || props.item.city) + //remove venue
  // props.item.city + // only city and country
  // (props.item.nationality ? ", " + props.item.nationality : "");
  props.item.city; // only city

  var _useState2 = (0,react.useState)((0,helpers/* calculateMilisecondDiff */.Hc)(new Date(), startDate)),
      durationInMiliseconds = _useState2[0],
      setDurationInMiliseconds = _useState2[1];

  var periodString = (0,formatHelpers/* formatPeriod */.Iu)(startDate, endDate, config/* Constants.dateFormat.DATE_FORMAT_LONG */.gT.dateFormat.DATE_FORMAT_LONG, timezoneData === null || timezoneData === void 0 ? void 0 : (_timezoneData$label = timezoneData.label) === null || _timezoneData$label === void 0 ? void 0 : _timezoneData$label.match(/\((.*?)\)/)[0]);
  var isShowDuration = status == 1;
  var isShowStatusString = status > 1;
  var isTBC = status === config/* Constants.festivalStatus.FE_STAT_UPCOMMING_TO_BE_UPDATED */.gT.festivalStatus.FE_STAT_UPCOMMING_TO_BE_UPDATED;
  var isReschedule = status === config/* Constants.festivalStatus.FE_STAT_RESCHEDULE_TO_BE_UPDATED */.gT.festivalStatus.FE_STAT_RESCHEDULE_TO_BE_UPDATED;
  var eventStatusItems = [{
    value: (0,helpers/* formatNumber */.uf)(totalSaved),
    label: t("key_saved"),
    type: config/* Constants.profileStatusType.PROFILE_STATUS_SAVED */.gT.profileStatusType.PROFILE_STATUS_SAVED
  }, {
    value: (0,helpers/* formatNumber */.uf)(totalGoing),
    label: t("key_going"),
    type: config/* Constants.profileStatusType.PROFILE_STATUS_GOING */.gT.profileStatusType.PROFILE_STATUS_GOING
  }, {
    value: (0,helpers/* formatNumber */.uf)(totalConnection),
    label: t("key_connections"),
    type: config/* Constants.profileStatusType.PROFILE_STATUS_CONNECTION */.gT.profileStatusType.PROFILE_STATUS_CONNECTION
  }];
  (0,react.useEffect)(function () {
    var interval = setInterval(function () {
      setDurationInMiliseconds((0,helpers/* calculateMilisecondDiff */.Hc)(new Date(), startDate));
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [id]);
  if (!props.item) return null;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [EventInfoView_styles.container, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: {
        alignSelf: "center",
        maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
        width: "100%"
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center"
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [EventInfoView_styles.title, isMobileVersion ? {
            alignSelf: "start",
            fontSize: 18,
            marginTop: 18
          } : {}],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
            children: title
          })
        }), (isOfficial === 1 || isPro === 1) && /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          onMouseOver: isMobileVersion ? null : function () {
            return setShowPopupOfficial(true);
          },
          onMouseLeave: isMobileVersion ? null : function () {
            return setShowPopupOfficial(false);
          },
          onClick: isMobileVersion ? function () {
            return officialBadgeModalRef.current.showModal();
          } : null,
          style: {
            marginLeft: -10,
            marginTop: -1,
            position: "relative",
            cursor: isMobileVersion ? "pointer" : "default"
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconVerifiedBadge */.rU.iconVerifiedBadge,
            alt: "badge official",
            width: 14,
            height: 14,
            layout: "fixed"
          }), showPopupOfficial && !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
            style: {
              position: "absolute",
              width: isMobileVersion ? 260 + 24 : 336 + 24,
              height: isMobileVersion ? 140 : 182,
              zIndex: 10,
              left: 0,
              top: -91,
              paddingLeft: 24
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
              style: (_ref = {
                backgroundColor: (0,formatHelpers/* getClass */.ll)("bg-gray1"),
                width: isMobileVersion ? 260 : 336,
                height: isMobileVersion ? 140 : 182,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingHorizontal: 22,
                borderRadius: 18
              }, (0,defineProperty/* default */.Z)(_ref, "width", "100%"), (0,defineProperty/* default */.Z)(_ref, "height", "100%"), (0,defineProperty/* default */.Z)(_ref, "boxShadow", "2px 2px 10px rgba(0,0,0,0.5)"), _ref),
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconVerifiedBadgeMedium */.rU.iconVerifiedBadgeMedium,
                alt: "verified account",
                width: isMobileVersion ? 24 : 35,
                height: isMobileVersion ? 24 : 35,
                layout: "fixed"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: {
                  fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
                  fontSize: isMobileVersion ? 16 : 20,
                  lineHeight: isMobileVersion ? 20 : 24,
                  color: config/* Colors.white */.wL.white,
                  marginVertical: isMobileVersion ? 9 : 14,
                  textAlign: "center"
                },
                children: "Official Account"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
                style: {
                  fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
                  fontSize: isMobileVersion ? 12 : 16,
                  lineHeight: isMobileVersion ? 16 : 18,
                  color: config/* Colors.white80 */.wL.white80,
                  textAlign: "center"
                },
                children: ["This is an official account verified by", " ", "Cocktayl"]
              })]
            })
          })]
        })]
      }), isShowDuration && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:px-0 px-4",
        children: isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)(DurationView/* default */.Z, {
          duration: durationInMiliseconds,
          style: [EventInfoView_styles.durationContainer, {
            marginTop: 16,
            marginBottom: 16
          }],
          isMobileVersion: isMobileVersion
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DurationView/* default */.Z, {
          duration: durationInMiliseconds,
          style: EventInfoView_styles.durationContainer,
          isMobileVersion: isMobileVersion
        })
      }), isShowStatusString && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "sm:px-0 px-4",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(EventStatusView/* default */.Z, {
          eventStatus: status,
          style: [EventInfoView_styles.durationContainer, isMobileVersion ? {
            marginTop: 16,
            marginBottom: 16
          } : {}],
          isMobileVersion: isMobileVersion
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex sm:flex-row flex-col sm:items-center items-start justify-between",
        children: [isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [EventInfoView_styles.rowContainer, {
            paddingHorizontal: 16
          }],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconLocationPin */.rU.iconLocationPin,
            style: EventInfoView_styles.locationPin,
            objectFit: "contain",
            height: 14,
            width: 14,
            layout: "fixed"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: {
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 10
            },
            children: [!isTBC && !isReschedule && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [EventInfoView_styles.text, EventInfoView_styles.locationText, {
                fontSize: 10
              }],
              numberOfLines: 1,
              ellipsizeMode: "tail",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
                style: {
                  fontStyle: "normal"
                },
                children: location
              })
            }), isVirtual && /*#__PURE__*/(0,jsx_runtime.jsx)(TagView, {
              title: t("key_virtual"),
              style: {
                marginLeft: 13
              },
              isMobileVersion: isMobileVersion
            }), isInPerson && /*#__PURE__*/(0,jsx_runtime.jsx)(TagView, {
              title: t("key_in_person"),
              style: {
                marginLeft: 13
              },
              isMobileVersion: isMobileVersion
            })]
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [EventInfoView_styles.rowContainer],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconLocationPin */.rU.iconLocationPin,
            style: EventInfoView_styles.locationPin,
            objectFit: "contain",
            height: 20,
            width: 20,
            layout: "fixed"
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: {
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              marginLeft: 10
            },
            children: [!isTBC && !isReschedule && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [EventInfoView_styles.text, EventInfoView_styles.locationText],
              numberOfLines: 1,
              ellipsizeMode: "tail",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
                style: {
                  fontStyle: "normal"
                },
                children: location
              })
            }), isVirtual && /*#__PURE__*/(0,jsx_runtime.jsx)(TagView, {
              title: t("key_virtual"),
              style: {
                marginLeft: 13
              }
            }), isInPerson && /*#__PURE__*/(0,jsx_runtime.jsx)(TagView, {
              title: t("key_in_person"),
              style: {
                marginLeft: 13
              }
            })]
          })]
        }), isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [EventInfoView_styles.rowContainer, {
            marginTop: 10,
            paddingHorizontal: 16
          }],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconBooking */.rU.iconBooking,
            style: EventInfoView_styles.locationPin,
            width: 14,
            height: 14,
            layout: "fixed",
            objectFit: "contain"
          }), !isTBC && !isReschedule && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: [EventInfoView_styles.text, EventInfoView_styles.locationText, {
              marginLeft: 10,
              fontSize: 10
            }],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("time", {
              children: periodString
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [EventInfoView_styles.rowContainer],
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconBooking */.rU.iconBooking,
            style: EventInfoView_styles.locationPin,
            width: 20,
            height: 20,
            layout: "fixed",
            objectFit: "contain"
          }), !isTBC && !isReschedule && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: [EventInfoView_styles.text, EventInfoView_styles.locationText, {
              marginLeft: 10
            }],
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("time", {
              children: periodString
            })
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* AlertModal */.VF, {
        icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
        ref: alertModalRef
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_OfficialBadgeModal, {
        ref: officialBadgeModalRef,
        isMobileVersion: isMobileVersion
      })]
    })
  });
};

var EventInfoView_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch",
    backgroundColor: config/* Colors.black */.wL.black,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25
  },
  title: {
    fontSize: 28,
    lineHeight: 32,
    marginTop: 32,
    paddingHorizontal: 16,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: "white",
    alignSelf: "center"
  },
  statusText: {
    fontSize: 16,
    color: "white",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  },
  durationContainer: {
    marginTop: 25,
    maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
    width: "100%",
    alignSelf: "center",
    marginBottom: 24
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  locationPin: {// width: 14,
    // height: 14,
    // marginRight: 6,
  },
  text: {
    color: "white",
    fontSize: 16,
    lineHeight: 18,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  },
  locationText: {},
  tagContainer: {
    height: 30,
    paddingHorizontal: 10,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 20,
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground
  },
  tagText: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.whiteText */.wL.whiteText
  },
  eventButtonContainer: {
    borderRadius: 12,
    height: 24,
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    alignItems: "center",
    justifyContent: "center",
    width: 104,
    flexDirection: "row"
  },
  buttonContainer: {
    borderRadius: 12,
    height: 24,
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    paddingHorizontal: 8
  },
  eventButtonText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    color: "white"
  },
  eventIcon: {
    width: 11,
    height: 11,
    marginRight: 4
  },
  buttonTitle: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 18,
    color: "white"
  },
  buttonTitleHighlight: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    color: "white"
  }
});
/* harmony default export */ var components_EventInfoView = (EventInfoView);
// EXTERNAL MODULE: ./src/modules/profile/components/ProfileBottomView.js + 2 modules
var ProfileBottomView = __webpack_require__(84972);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/modules/profile/modals/IDProfileModal/IDProfileContainer.js









 //import Clipboard from "@react-native-clipboard/clipboard";




var IDProfileContainer = function IDProfileContainer(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var item = props.item,
      isMobileVersion = props.isMobileVersion;
  var textAreaRef = (0,react.useRef)(null);
  var idProfileText = "";

  if (item.globalId) {
    idProfileText = item.globalId;
  } else if (item.profileId) {
    idProfileText = item.profileId;
  }

  var copyTextToClipboard = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              textAreaRef.current.select();
              document.execCommand("copy"); // if ("clipboard" in navigator) {
              //   return await navigator.clipboard.writeText(text);
              // } else {
              //   return document.execCommand("copy", true, text);
              // }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function copyTextToClipboard(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var onButtonAction = function onButtonAction(actionType, e) {
    if (props.onButtonAction) {
      props.onButtonAction({
        modalType: config/* Constants.profileModalType.PROFILE_MODAL_ID_PROFILE */.gT.profileModalType.PROFILE_MODAL_ID_PROFILE,
        actionType: actionType
      });
    }

    if (actionType == config/* Constants.actionType.ACTION_COPY */.gT.actionType.ACTION_COPY) {
      copyTextToClipboard(e);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [IDProfileContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: IDProfileContainer_styles.contentContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [IDProfileContainer_styles.text, isMobileVersion ? {
          fontSize: 12
        } : {}],
        children: idProfileText
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [IDProfileContainer_styles.footerButton, isMobileVersion ? {
        height: 72
      } : {}],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: IDProfileContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: t("key_profile_button_cancel"),
          style: [IDProfileContainer_styles.buttonStyle, {
            borderColor: (0,formatHelpers/* getClass */.ll)("border-black")
          }],
          borderedTextColor: (0,formatHelpers/* getClass */.ll)("text-white"),
          bordered: true,
          fontSize: isMobileVersion ? 12 : 16,
          onPress: function onPress(e) {
            return onButtonAction(config/* Constants.actionType.ACTION_CANCEL */.gT.actionType.ACTION_CANCEL, e);
          },
          isMobileVersion: isMobileVersion
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
        style: IDProfileContainer_styles.footerItem,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: t("key_profile_button_copy"),
          style: IDProfileContainer_styles.buttonStyle,
          filled: true,
          fontSize: isMobileVersion ? 12 : 16,
          onPress: function onPress(e) {
            return onButtonAction(config/* Constants.actionType.ACTION_COPY */.gT.actionType.ACTION_COPY, e);
          },
          isMobileVersion: isMobileVersion,
          filledColor:  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 :  false ? 0 : null,
          filledTextColor:  false ? 0 : null
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
      ref: textAreaRef,
      value: idProfileText,
      className: "opacity-0 absolute top-0 left-0",
      readOnly: true
    })]
  });
};

var IDProfileContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  contentContainer: {
    paddingVertical: 16,
    alignSelf: "stretch"
  },
  text: {
    textAlign: "center",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 14,
    color: (0,formatHelpers/* getClass */.ll)("text-white")
  },
  footerButton: {
    borderTopColor: (0,formatHelpers/* getClass */.ll)("border-tabBottomColor"),
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingTop: 16,
    marginHorizontal: -16,
    marginBottom: -16,
    marginTop: 4,
    alignSelf: "stretch",
    height: 90
  },
  footerItem: {
    paddingHorizontal: 6,
    flex: 1
  },
  buttonStyle: {
    marginBottom: 16
  }
});
/* harmony default export */ var IDProfileModal_IDProfileContainer = (IDProfileContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/IDProfileModal/index.js


function IDProfileModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function IDProfileModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? IDProfileModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : IDProfileModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var IDProfileModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, IDProfileModal_objectSpread(IDProfileModal_objectSpread({
    ref: ref
  }, props), {}, {
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(IDProfileModal_IDProfileContainer, IDProfileModal_objectSpread(IDProfileModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction
    }))
  }));
});
/* harmony default export */ var modals_IDProfileModal = (IDProfileModal);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ContactModal/ContactContainer.js











 // import { chatClient } from '../../../../helpers/useChatClient'




var ContactContainer = function ContactContainer(props) {
  var _socialIds$find, _socialIds$find2, _socialIds$find3, _socialIds$find4, _socialIds$find5, _socialIds$find6;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;
  if (!props.contact) return null;
  var _props$contact = props.contact,
      email = _props$contact.email,
      phone = _props$contact.phone,
      website = _props$contact.website,
      instagramUrl = _props$contact.instagramUrl,
      facebookUrl = _props$contact.facebookUrl,
      twitterUrl = _props$contact.twitterUrl,
      youtubeUrl = _props$contact.youtubeUrl,
      spotifyUrl = _props$contact.spotifyUrl,
      tiktokUrl = _props$contact.tiktokUrl;
  var _props$item = props.item,
      id = _props$item.id,
      profileId = _props$item.profileId,
      title = _props$item.title,
      nickname = _props$item.nickname,
      socialFacebook = _props$item.socialFacebook,
      socialInstagram = _props$item.socialInstagram,
      socialTwitter = _props$item.socialTwitter,
      socialSpotify = _props$item.socialSpotify,
      socialYoutube = _props$item.socialYoutube,
      socialTiktok = _props$item.socialTiktok,
      socialIds = _props$item.socialIds,
      youtube = _props$item.youtube,
      instagram = _props$item.instagram,
      tiktok = _props$item.tiktok,
      facebook = _props$item.facebook,
      spotify = _props$item.spotify,
      twitter = _props$item.twitter,
      privacy = _props$item.privacy,
      wikipedia = _props$item.wikipedia,
      contactWebsite_follow_link = _props$item.contactWebsite_follow_link;

  var getURL = function getURL(socialType, username) {
    var prefix = "";

    if (socialType == config/* Constants.socialType.SOCIAL_TYPE_FACEBOOK */.gT.socialType.SOCIAL_TYPE_FACEBOOK) {
      prefix = "https://facebook.com/";
    } else if (socialType == config/* Constants.socialType.SOCIAL_TYPE_INSTAGRAM */.gT.socialType.SOCIAL_TYPE_INSTAGRAM) {
      prefix = "https://instagram.com/";
    } else if (socialType == config/* Constants.socialType.SOCIAL_TYPE_TWITTER */.gT.socialType.SOCIAL_TYPE_TWITTER) {
      prefix = "https://twitter.com/";
    } else if (socialType == config/* Constants.socialType.SOCIAL_TYPE_YOUTUBE */.gT.socialType.SOCIAL_TYPE_YOUTUBE) {
      prefix = "https://youtube.com/";
    }

    return username ? prefix + username : null;
  };

  var socialLinks = [{
    icon: config/* Images.iconInstagramLinkCircle */.rU.iconInstagramLinkCircle,
    url: instagramUrl || socialInstagram || instagram || getURL(config/* Constants.socialType.SOCIAL_TYPE_INSTAGRAM */.gT.socialType.SOCIAL_TYPE_INSTAGRAM, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_INSTAGRAM */.gT.socialType.SOCIAL_TYPE_INSTAGRAM;
    })) === null || _socialIds$find === void 0 ? void 0 : _socialIds$find.username)
  }, {
    icon: config/* Images.iconFacebookLinkCircle */.rU.iconFacebookLinkCircle,
    url: facebookUrl || socialFacebook || facebook || getURL(config/* Constants.socialType.SOCIAL_TYPE_FACEBOOK */.gT.socialType.SOCIAL_TYPE_FACEBOOK, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find2 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_FACEBOOK */.gT.socialType.SOCIAL_TYPE_FACEBOOK;
    })) === null || _socialIds$find2 === void 0 ? void 0 : _socialIds$find2.username)
  }, {
    icon: config/* Images.iconTwitterLinkCircle */.rU.iconTwitterLinkCircle,
    url: twitterUrl || socialTwitter || twitter || getURL(config/* Constants.socialType.SOCIAL_TYPE_TWITTER */.gT.socialType.SOCIAL_TYPE_TWITTER, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find3 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_TWITTER */.gT.socialType.SOCIAL_TYPE_TWITTER;
    })) === null || _socialIds$find3 === void 0 ? void 0 : _socialIds$find3.username)
  }, {
    icon: config/* Images.iconYoutubeLinkCircle */.rU.iconYoutubeLinkCircle,
    url: youtubeUrl || socialYoutube || youtube || getURL(config/* Constants.socialType.SOCIAL_TYPE_YOUTUBE */.gT.socialType.SOCIAL_TYPE_YOUTUBE, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find4 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_YOUTUBE */.gT.socialType.SOCIAL_TYPE_YOUTUBE;
    })) === null || _socialIds$find4 === void 0 ? void 0 : _socialIds$find4.username)
  }, {
    icon: config/* Images.iconSpotifyLinkCircle */.rU.iconSpotifyLinkCircle,
    url: spotifyUrl || socialSpotify || spotify || getURL(config/* Constants.socialType.SOCIAL_TYPE_SPOTIFY */.gT.socialType.SOCIAL_TYPE_SPOTIFY, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find5 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_SPOTIFY */.gT.socialType.SOCIAL_TYPE_SPOTIFY;
    })) === null || _socialIds$find5 === void 0 ? void 0 : _socialIds$find5.username)
  }, {
    icon: config/* Images.iconTiktokLinkCircle */.rU.iconTiktokLinkCircle,
    url: tiktokUrl || socialTiktok || tiktok || getURL(config/* Constants.socialType.SOCIAL_TYPE_TIKTOK */.gT.socialType.SOCIAL_TYPE_TIKTOK, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find6 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_TIKTOK */.gT.socialType.SOCIAL_TYPE_TIKTOK;
    })) === null || _socialIds$find6 === void 0 ? void 0 : _socialIds$find6.username)
  }].concat( false ? 0 : []);
  var activeSocialLinks = [];
  socialLinks.forEach(function (item) {
    if (item && item.url != null && item.url != "") {
      activeSocialLinks.push(item);
    }
  });

  var onButtonAction = function onButtonAction(actionType) {
    if (props.onButtonAction) {
      props.onButtonAction({
        modalType: config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT,
        actionType: actionType
      });
    }
  };

  var renderEmailItem = function renderEmailItem(icon, label, style) {
    if (!label) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      style: [ContactContainer_styles.rowContainer, style],
      onPress: function onPress() {
        onOpenLink("mailto:".concat(label));
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: isMobileVersion ? 16 : 20,
        height: isMobileVersion ? 16 : 20,
        layout: "fixed",
        source: icon,
        style: ContactContainer_styles.icon,
        resizeMode: "contain",
        alt: "email"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [ContactContainer_styles.label, isMobileVersion ? {
          fontSize: 12
        } : {}, {
          marginLeft: 10
        }],
        children: label.length > 40 ? label.substring(0, 40) + "..." : label
      })]
    });
  };

  var renderPhoneItem = function renderPhoneItem(icon, label, style) {
    if (!label) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      style: [ContactContainer_styles.rowContainer, style],
      onPress: function onPress() {
        onOpenLink("tel:".concat(label === null || label === void 0 ? void 0 : label.replace(/ /g, "")));
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: isMobileVersion ? 16 : 20,
        height: isMobileVersion ? 16 : 20,
        layout: "fixed",
        source: icon,
        style: ContactContainer_styles.icon,
        resizeMode: "contain",
        alt: "phone"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [ContactContainer_styles.label, isMobileVersion ? {
          fontSize: 12
        } : {}, {
          marginLeft: 6
        }],
        children: label === null || label === void 0 ? void 0 : label.replace(/ /g, "")
      })]
    });
  };

  var renderWebsiteItem = function renderWebsiteItem(icon, label, style) {
    if (!label) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [ContactContainer_styles.rowContainer, style],
      onPress: function onPress() {
        onOpenLink(label);
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: isMobileVersion ? 16 : 20,
        height: isMobileVersion ? 16 : 20,
        layout: "fixed",
        source: icon,
        style: ContactContainer_styles.icon,
        resizeMode: "contain",
        alt: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [ContactContainer_styles.label, isMobileVersion ? {
          fontSize: 12
        } : {}, {
          marginLeft: 6,
          flex: 1
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: label,
          children: contactWebsite_follow_link ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            children: label.length > 40 ? label.substring(0, 40) + "..." : label
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "nofollow",
            target: "_blank",
            children: label.length > 40 ? label.substring(0, 40) + "..." : label
          })
        })
      })]
    });
  };

  var onOpenLink = function onOpenLink(url) {
    var win = window.open(url, "_blank");
    win.focus();
  };

  var renderSocialLinkItem = function renderSocialLinkItem(item, index, totalCount) {
    var url = item.url,
        icon = item.icon;
    var isLast = index == totalCount - 1;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      style: [ContactContainer_styles.socialLinkIcon, {
        marginRight: isLast ? 0 : 18
      }],
      onPress: function onPress() {
        onOpenLink(url);
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: 40,
        height: 40,
        layout: "fixed",
        source: icon,
        style: ContactContainer_styles.socialLinkIcon,
        resizeMode: "contain",
        alt: "social link"
      })
    }, index + "social-link");
  };

  var renderSocialItems = function renderSocialItems(socialItems) {
    var totalCount = socialItems.length;
    return socialItems.map(function (socialItem, index) {
      return renderSocialLinkItem(socialItem, index, totalCount);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [ContactContainer_styles.container, props.style],
    children: [privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        padding: 20,
        alignItems: "center"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: {
          color: config/* Colors.grayText */.wL.grayText,
          fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
          fontSize: 16,
          lineHeight: 20
        },
        children: t("key_private_mode_text")
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [ContactContainer_styles.contentContainer, props.category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? {
        paddingTop: 36
      } : {}],
      children: [!email && !phone && !website && activeSocialLinks.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [ContactContainer_styles.emptyText, isMobileVersion ? {
          fontSize: 12
        } : {}],
        children: t("key_contact_empty")
      }), renderEmailItem(config/* Images.iconEmailColored */.rU.iconEmailColored, email), renderPhoneItem(config/* Images.iconPhoneColored */.rU.iconPhoneColored, phone, {
        marginTop: 16
      }), renderWebsiteItem(config/* Images.iconWebsiteColored */.rU.iconWebsiteColored, website && !(website !== null && website !== void 0 && website.includes("http")) ? "https://".concat(website) : website, {
        marginTop: 16
      })]
    }), activeSocialLinks.length > 0 && privacy !== config/* Constants.privacyType.private */.gT.privacyType["private"] && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: ContactContainer_styles.footerButton,
      children: renderSocialItems(activeSocialLinks)
    }), privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: ContactContainer_styles.footerButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
        buttonTitle: t("key_close"),
        style: [ContactContainer_styles.buttonStyle, {
          marginBottom: 16,
          width: "100%",
          paddingHorizontal: 20
        }],
        filled: true,
        onPress: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      })
    })]
  });
};

var ContactContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  rowContainer: {
    alignItems: "center",
    flexDirection: "row"
  },
  contentContainer: {
    paddingTop: 20,
    paddingBottom: 16,
    alignSelf: "stretch",
    alignItems: "center"
  },
  text: {
    textAlign: "center",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 14,
    color: (0,formatHelpers/* getClass */.ll)("text-white")
  },
  socialLinkIcon: {
    width: 40,
    height: 40
  },
  footerButton: {
    borderTopColor: (0,formatHelpers/* getClass */.ll)("border-tabBottomColor"),
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: -16,
    paddingHorizontal: 16,
    alignSelf: "stretch",
    justifyContent: "center",
    height: 76
  },
  footerItem: {
    paddingHorizontal: 6,
    flex: 1
  },
  icon: {
    width: 14,
    height: 14
  },
  label: {
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium,
    fontSize: 16,
    lineHeight: 20
  },
  emptyText: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.grayText */.wL.grayText,
    marginTop: 16
  }
});
/* harmony default export */ var ContactModal_ContactContainer = (ContactContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ContactModal/index.js


function ContactModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ContactModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ContactModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ContactModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ContactModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, ContactModal_objectSpread(ContactModal_objectSpread({
    ref: ref
  }, props), {}, {
    modalType: config/* Constants.modalType.MODAL_TYPE_CENTER */.gT.modalType.MODAL_TYPE_CENTER,
    closableWithOutsideTouch: true // hideClose
    ,
    title: t("key_modal_title_contact"),
    icon: config/* Images.iconChatColor */.rU.iconChatColor,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactModal_ContactContainer, ContactModal_objectSpread(ContactModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction,
      isMobileVersion: isMobileVersion
    }))
  }));
});
/* harmony default export */ var modals_ContactModal = (ContactModal);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
;// CONCATENATED MODULE: ./src/modules/profile/modals/CalendarModal/CalendarContainer.js


function CalendarContainer_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CalendarContainer_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CalendarContainer_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CalendarContainer_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var CalendarContainer = function CalendarContainer(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion,
      category = props.category,
      item = props.item;

  var _useState = (0,react.useState)(0),
      selectedTabIndex = _useState[0],
      setSelectedTabIndex = _useState[1];

  var tabList = [{
    id: 1,
    title: "Hours"
  }, {
    id: 3,
    title: "Year"
  }];
  var calendar = item.calendar;
  var venueCalendarTimes = [{
    weekday: "Monday",
    isActive: false,
    childs: []
  }, {
    weekday: "Tuesday",
    isActive: false,
    childs: []
  }, {
    weekday: "Wednesday",
    isActive: false,
    childs: []
  }, {
    weekday: "Thursday",
    isActive: false,
    childs: []
  }, {
    weekday: "Friday",
    isActive: false,
    childs: []
  }, {
    weekday: "Saturday",
    isActive: false,
    childs: []
  }, {
    weekday: "Sunday",
    isActive: false,
    childs: []
  }];
  var venueMonth = [{
    month: "January",
    isActive: false
  }, {
    month: "February",
    isActive: false
  }, {
    month: "March",
    isActive: false
  }, {
    month: "April",
    isActive: false
  }, {
    month: "May",
    isActive: false
  }, {
    month: "June",
    isActive: false
  }, {
    month: "July",
    isActive: false
  }, {
    month: "August",
    isActive: false
  }, {
    month: "September",
    isActive: false
  }, {
    month: "October",
    isActive: false
  }, {
    month: "November",
    isActive: false
  }, {
    month: "December",
    isActive: false
  }];
  calendar.forEach(function (item) {
    venueCalendarTimes.forEach(function (item2) {
      if (item.weekday === item2.weekday) {
        if (item.startTime !== "") {
          var _venueCalendarTimes$f, _venueCalendarTimes$f2;

          item2.isActive = item.isActive;
          (_venueCalendarTimes$f = venueCalendarTimes.find(function (i) {
            return i.weekday === item2.weekday;
          })) === null || _venueCalendarTimes$f === void 0 ? void 0 : (_venueCalendarTimes$f2 = _venueCalendarTimes$f.childs) === null || _venueCalendarTimes$f2 === void 0 ? void 0 : _venueCalendarTimes$f2.push({
            weekday: item2.weekday,
            startTime: item.startTime,
            endTime: item.endTime
          });
        }
      } else {
        var _venueCalendarTimes$f3, _venueCalendarTimes$f4;

        (_venueCalendarTimes$f3 = venueCalendarTimes.find(function (i) {
          return i.weekday === item2.weekday;
        })) === null || _venueCalendarTimes$f3 === void 0 ? void 0 : (_venueCalendarTimes$f4 = _venueCalendarTimes$f3.childs) === null || _venueCalendarTimes$f4 === void 0 ? void 0 : _venueCalendarTimes$f4.push({
          weekday: item2.weekday,
          startTime: "",
          endTime: ""
        });
      }
    });
    venueMonth.forEach(function (item2) {
      if (item.month === item2.month) {
        item2.isActive = item.isActive;
      }
    });
  });
  venueCalendarTimes = venueCalendarTimes.map(function (item) {
    return CalendarContainer_objectSpread(CalendarContainer_objectSpread({}, item), {}, {
      childs: (0,lodash.uniqBy)(item.childs, "startTime")
    });
  }); // Filter out empty startTime objects from weekdays where any other weekday has a non-empty startTime

  venueCalendarTimes = venueCalendarTimes.map(function (item) {
    if (venueCalendarTimes.some(function (weekday) {
      return weekday.weekday !== item.weekday && weekday.childs.some(function (child) {
        return child.startTime !== "";
      });
    })) {
      item.childs = item.childs.filter(function (child) {
        return child.startTime !== "";
      });
    }

    return item;
  }); // Check if the childs array is empty and add an object with empty startTime and endTime

  venueCalendarTimes = venueCalendarTimes.map(function (item) {
    if (item.childs.length === 0) {
      item.childs.push({
        isActive: false,
        weekday: item.weekday,
        startTime: "",
        endTime: ""
      });
    }

    return item;
  });

  var onSelectTab = function onSelectTab(item, index) {
    setSelectedTabIndex(index);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [CalendarContainer_styles.container, props.style],
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CTabSelector */.Qv, {
      tabItemType: "bottom-line-tab",
      items: tabList,
      showInView: true,
      selectedIndex: selectedTabIndex,
      onSelectTab: onSelectTab,
      containerStyle: CalendarContainer_styles.tabContainer
    }), selectedTabIndex === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "p-[20px] flex flex-col items-center",
      children: venueCalendarTimes.map(function (item, index) {
        var _item$weekday, _item$weekday$substri;

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "text-white sm:text-base text-sm font-medium",
          children: [(_item$weekday = item.weekday) === null || _item$weekday === void 0 ? void 0 : (_item$weekday$substri = _item$weekday.substring(0, 3)) === null || _item$weekday$substri === void 0 ? void 0 : _item$weekday$substri.toUpperCase(), "\xA0\xA0", !item.isActive ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "text-grayText2 uppercase",
            children: "Closed"
          }) : item.childs.map(function (item2, index2) {
            var _item2$startTime, _item2$endTime;

            return /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
              className: "text-grayText2",
              children: [(_item2$startTime = item2.startTime) === null || _item2$startTime === void 0 ? void 0 : _item2$startTime.substring(0, 5), "-", (_item2$endTime = item2.endTime) === null || _item2$endTime === void 0 ? void 0 : _item2$endTime.substring(0, 5), index2 < item.childs.length - 1 ? /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "text-white",
                children: " - "
              }) : ""]
            }, index2);
          })]
        }, index);
      })
    }), selectedTabIndex === 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "p-[20px] flex flex-row flex-wrap gap-0 items-center justify-center",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-[45%]",
        children: venueMonth.filter(function (i, index) {
          return index < 6;
        }).map(function (item, index) {
          var _item$month, _item$month2, _item$month2$substrin;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-white sm:text-base text-sm font-medium flex items-center justify-center",
            children: [((_item$month = item.month) === null || _item$month === void 0 ? void 0 : _item$month.toUpperCase()) == "JUNE" ? "JUNE" : (_item$month2 = item.month) === null || _item$month2 === void 0 ? void 0 : (_item$month2$substrin = _item$month2.substring(0, 3)) === null || _item$month2$substrin === void 0 ? void 0 : _item$month2$substrin.toUpperCase(), "\xA0\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-grayText2 uppercase",
              children: !item.isActive ? "Closed" : "Open"
            })]
          }, index);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "w-[45%]",
        children: venueMonth.filter(function (i, index) {
          return index >= 6;
        }).map(function (item, index) {
          var _item$month3, _item$month4, _item$month4$substrin;

          return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "text-white sm:text-base text-sm font-medium flex items-center justify-center",
            children: [((_item$month3 = item.month) === null || _item$month3 === void 0 ? void 0 : _item$month3.toUpperCase()) == "JUNE" ? "JUNE" : (_item$month4 = item.month) === null || _item$month4 === void 0 ? void 0 : (_item$month4$substrin = _item$month4.substring(0, 3)) === null || _item$month4$substrin === void 0 ? void 0 : _item$month4$substrin.toUpperCase(), "\xA0\xA0", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "text-grayText2 uppercase",
              children: !item.isActive ? "Closed" : "Open"
            })]
          }, index);
        })
      })]
    })]
  });
};

var CalendarContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  rowContainer: {
    alignItems: "center",
    flexDirection: "row"
  },
  contentContainer: {
    paddingTop: 36,
    paddingBottom: 16,
    alignSelf: "stretch",
    alignItems: "center"
  },
  text: {
    textAlign: "center",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 14,
    color: config/* Colors.white */.wL.white
  },
  socialLinkIcon: {
    width: 40,
    height: 40
  },
  footerButton: {
    borderTopColor: config/* Colors.tabBottomColor */.wL.tabBottomColor,
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: -16,
    paddingHorizontal: 16,
    alignSelf: "stretch",
    justifyContent: "center",
    height: 76
  },
  footerItem: {
    paddingHorizontal: 6,
    flex: 1
  },
  icon: {
    width: 14,
    height: 14
  },
  label: {
    color: config/* Colors.white */.wL.white,
    fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium,
    fontSize: 16,
    lineHeight: 20
  },
  emptyText: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.grayText */.wL.grayText,
    marginTop: 16
  }
});
/* harmony default export */ var CalendarModal_CalendarContainer = (CalendarContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/CalendarModal/index.js


function CalendarModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function CalendarModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? CalendarModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : CalendarModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var CalendarModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, CalendarModal_objectSpread(CalendarModal_objectSpread({
    ref: ref
  }, props), {}, {
    modalType: config/* Constants.modalType.MODAL_TYPE_CENTER */.gT.modalType.MODAL_TYPE_CENTER,
    closableWithOutsideTouch: true // hideClose
    ,
    title: t("key_modal_title_calendar"),
    icon: config/* Images.iconCalendar */.rU.iconCalendar,
    iconWidth: isMobileVersion ? 20 : 28,
    iconHeight: isMobileVersion ? 20 : 28,
    iconStyle: isMobileVersion ? null : {
      marginTop: -2
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(CalendarModal_CalendarContainer, CalendarModal_objectSpread(CalendarModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction,
      isMobileVersion: isMobileVersion
    }))
  }));
});
/* harmony default export */ var modals_CalendarModal = (CalendarModal);
;// CONCATENATED MODULE: ./src/modules/profile/modals/BookingModal/BookingContainer.js











 // import { chatClient } from '../../../../helpers/useChatClient'




var BookingContainer = function BookingContainer(props) {
  var _socialIds$find, _socialIds$find2, _socialIds$find3, _socialIds$find4, _socialIds$find5;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;
  if (!props.contact) return null;
  var _props$contact = props.contact,
      email = _props$contact.email,
      phone = _props$contact.phone,
      website = _props$contact.website,
      instagramUrl = _props$contact.instagramUrl,
      facebookUrl = _props$contact.facebookUrl,
      twitterUrl = _props$contact.twitterUrl,
      youtubeUrl = _props$contact.youtubeUrl,
      spotifyUrl = _props$contact.spotifyUrl;
  var _props$item = props.item,
      id = _props$item.id,
      profileId = _props$item.profileId,
      title = _props$item.title,
      nickname = _props$item.nickname,
      socialFacebook = _props$item.socialFacebook,
      socialInstagram = _props$item.socialInstagram,
      socialTwitter = _props$item.socialTwitter,
      socialSpotify = _props$item.socialSpotify,
      socialYoutube = _props$item.socialYoutube,
      socialTiktok = _props$item.socialTiktok,
      socialIds = _props$item.socialIds,
      youtube = _props$item.youtube,
      instagram = _props$item.instagram,
      tiktok = _props$item.tiktok,
      facebook = _props$item.facebook,
      spotify = _props$item.spotify,
      twitter = _props$item.twitter,
      privacy = _props$item.privacy,
      contactWebsite_follow_link = _props$item.contactWebsite_follow_link; // const channelId = `from_${user?.user?.id}_to_${profileId || id}`
  // const channel = chatClient.userID
  //   ? chatClient.channel('messaging', channelId, {
  //       // name: title || nickname,
  //       members: [
  //         user?.user?.id?.toString(),
  //         profileId?.toString() || id?.toString(),
  //       ],
  //     })
  //   : null

  var getURL = function getURL(socialType, username) {
    var prefix = "";

    if (socialType == config/* Constants.socialType.SOCIAL_TYPE_FACEBOOK */.gT.socialType.SOCIAL_TYPE_FACEBOOK) {
      prefix = "https://facebook.com/";
    } else if (socialType == config/* Constants.socialType.SOCIAL_TYPE_INSTAGRAM */.gT.socialType.SOCIAL_TYPE_INSTAGRAM) {
      prefix = "https://instagram.com/";
    } else if (socialType == config/* Constants.socialType.SOCIAL_TYPE_TWITTER */.gT.socialType.SOCIAL_TYPE_TWITTER) {
      prefix = "https://twitter.com/";
    } else if (socialType == config/* Constants.socialType.SOCIAL_TYPE_YOUTUBE */.gT.socialType.SOCIAL_TYPE_YOUTUBE) {
      prefix = "https://youtube.com/";
    }

    return username ? prefix + username : null;
  };

  var socialLinks = [{
    icon: config/* Images.iconInstagramLinkCircle */.rU.iconInstagramLinkCircle,
    url: instagramUrl || socialInstagram || instagram || getURL(config/* Constants.socialType.SOCIAL_TYPE_INSTAGRAM */.gT.socialType.SOCIAL_TYPE_INSTAGRAM, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_INSTAGRAM */.gT.socialType.SOCIAL_TYPE_INSTAGRAM;
    })) === null || _socialIds$find === void 0 ? void 0 : _socialIds$find.username)
  }, {
    icon: config/* Images.iconFacebookLinkCircle */.rU.iconFacebookLinkCircle,
    url: facebookUrl || socialFacebook || facebook || getURL(config/* Constants.socialType.SOCIAL_TYPE_FACEBOOK */.gT.socialType.SOCIAL_TYPE_FACEBOOK, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find2 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_FACEBOOK */.gT.socialType.SOCIAL_TYPE_FACEBOOK;
    })) === null || _socialIds$find2 === void 0 ? void 0 : _socialIds$find2.username)
  }, {
    icon: config/* Images.iconTwitterLinkCircle */.rU.iconTwitterLinkCircle,
    url: twitterUrl || socialTwitter || twitter || getURL(config/* Constants.socialType.SOCIAL_TYPE_TWITTER */.gT.socialType.SOCIAL_TYPE_TWITTER, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find3 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_TWITTER */.gT.socialType.SOCIAL_TYPE_TWITTER;
    })) === null || _socialIds$find3 === void 0 ? void 0 : _socialIds$find3.username)
  }, {
    icon: config/* Images.iconYoutubeLinkCircle */.rU.iconYoutubeLinkCircle,
    url: youtubeUrl || socialYoutube || youtube || getURL(config/* Constants.socialType.SOCIAL_TYPE_YOUTUBE */.gT.socialType.SOCIAL_TYPE_YOUTUBE, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find4 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_YOUTUBE */.gT.socialType.SOCIAL_TYPE_YOUTUBE;
    })) === null || _socialIds$find4 === void 0 ? void 0 : _socialIds$find4.username)
  }, {
    icon: config/* Images.iconSpotifyLinkCircle */.rU.iconSpotifyLinkCircle,
    url: spotifyUrl || socialSpotify || spotify || getURL(config/* Constants.socialType.SOCIAL_TYPE_SPOTIFY */.gT.socialType.SOCIAL_TYPE_SPOTIFY, socialIds === null || socialIds === void 0 ? void 0 : (_socialIds$find5 = socialIds.find(function (i) {
      return i.socialType === config/* Constants.socialType.SOCIAL_TYPE_SPOTIFY */.gT.socialType.SOCIAL_TYPE_SPOTIFY;
    })) === null || _socialIds$find5 === void 0 ? void 0 : _socialIds$find5.username)
  }];
  var activeSocialLinks = [];
  socialLinks.forEach(function (item) {
    if (item && item.url != null && item.url != "") {
      activeSocialLinks.push(item);
    }
  });

  var onButtonAction = function onButtonAction(actionType) {
    if (props.onButtonAction) {
      props.onButtonAction({
        modalType: config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT,
        actionType: actionType
      });
    }
  };

  var renderEmailItem = function renderEmailItem(icon, label, style) {
    if (!label) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      style: [BookingContainer_styles.rowContainer, style],
      onPress: function onPress() {
        onOpenLink("mailto:".concat(label));
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: isMobileVersion ? 16 : 20,
        height: isMobileVersion ? 16 : 20,
        layout: "fixed",
        source: icon,
        style: BookingContainer_styles.icon,
        resizeMode: "contain",
        alt: "email"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [BookingContainer_styles.label, isMobileVersion ? {
          fontSize: 12
        } : {}, {
          marginLeft: 10
        }],
        children: label
      })]
    });
  };

  var renderPhoneItem = function renderPhoneItem(icon, label, style) {
    if (!label) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
      style: [BookingContainer_styles.rowContainer, style],
      onPress: function onPress() {
        onOpenLink("tel:".concat(label === null || label === void 0 ? void 0 : label.replace(/ /g, "")));
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: isMobileVersion ? 16 : 20,
        height: isMobileVersion ? 16 : 20,
        layout: "fixed",
        source: icon,
        style: BookingContainer_styles.icon,
        resizeMode: "contain",
        alt: "phone"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [BookingContainer_styles.label, isMobileVersion ? {
          fontSize: 12
        } : {}, {
          marginLeft: 6
        }],
        children: label === null || label === void 0 ? void 0 : label.replace(/ /g, "")
      })]
    });
  };

  var renderWebsiteItem = function renderWebsiteItem(icon, label, style) {
    if (!label) return null;
    return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [BookingContainer_styles.rowContainer, style],
      onPress: function onPress() {
        onOpenLink(label);
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: isMobileVersion ? 16 : 20,
        height: isMobileVersion ? 16 : 20,
        layout: "fixed",
        source: icon,
        style: BookingContainer_styles.icon,
        resizeMode: "contain",
        alt: "website"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [BookingContainer_styles.label, isMobileVersion ? {
          fontSize: 12
        } : {}, {
          marginLeft: 6,
          flex: 1
        }],
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: label,
          children: contactWebsite_follow_link ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            target: "_blank",
            children: label.length > 40 ? label.substring(0, 40) + "..." : label
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            rel: "nofollow",
            target: "_blank",
            children: label.length > 40 ? label.substring(0, 40) + "..." : label
          })
        })
      })]
    });
  };

  var onOpenLink = function onOpenLink(url) {
    var win = window.open(url, "_blank");
    win.focus();
  };

  var renderSocialLinkItem = function renderSocialLinkItem(item, index, totalCount) {
    var url = item.url,
        icon = item.icon;
    var isLast = index == totalCount - 1;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      style: [BookingContainer_styles.socialLinkIcon, {
        marginRight: isLast ? 0 : 18
      }],
      onPress: function onPress() {
        onOpenLink(url);
        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: 40,
        height: 40,
        layout: "fixed",
        source: icon,
        style: BookingContainer_styles.socialLinkIcon,
        resizeMode: "contain",
        alt: "social link"
      })
    }, index + "social-link");
  };

  var renderSocialItems = function renderSocialItems(socialItems) {
    var totalCount = socialItems.length;
    return socialItems.map(function (socialItem, index) {
      return renderSocialLinkItem(socialItem, index, totalCount);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [BookingContainer_styles.container, props.style],
    children: [privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] ? /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: {
        padding: 20,
        alignItems: "center"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: {
          color: config/* Colors.grayText */.wL.grayText,
          fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
          fontSize: 16,
          lineHeight: 20
        },
        children: t("key_private_mode_text")
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: BookingContainer_styles.contentContainer,
      children: [!email && !phone && !website && activeSocialLinks.length === 0 && /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [BookingContainer_styles.emptyText, isMobileVersion ? {
          fontSize: 12
        } : {}],
        children: t("key_contact_empty")
      }), renderEmailItem(config/* Images.iconEmailColored */.rU.iconEmailColored, email), renderPhoneItem(config/* Images.iconPhoneColored */.rU.iconPhoneColored, phone, {
        marginTop: 16
      }), renderWebsiteItem(config/* Images.iconWebsiteColored */.rU.iconWebsiteColored, website && !(website !== null && website !== void 0 && website.includes("http")) ? "https://".concat(website) : website, {
        marginTop: 16
      })]
    }), activeSocialLinks.length > 0 && privacy !== config/* Constants.privacyType.private */.gT.privacyType["private"] && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: BookingContainer_styles.footerButton,
      children: renderSocialItems(activeSocialLinks)
    }), privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: BookingContainer_styles.footerButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
        buttonTitle: t("key_close"),
        style: [BookingContainer_styles.buttonStyle, {
          marginBottom: 16,
          width: "100%",
          paddingHorizontal: 20
        }],
        filled: true,
        onPress: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
          return regenerator_default().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))
      })
    })]
  });
};

var BookingContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  rowContainer: {
    alignItems: "center",
    flexDirection: "row"
  },
  contentContainer: {
    paddingTop: 36,
    paddingBottom: 16,
    alignSelf: "stretch",
    alignItems: "center"
  },
  text: {
    textAlign: "center",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 14,
    color: (0,formatHelpers/* getClass */.ll)("text-white")
  },
  socialLinkIcon: {
    width: 40,
    height: 40
  },
  footerButton: {
    borderTopColor: (0,formatHelpers/* getClass */.ll)("border-tabBottomColor"),
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: -16,
    paddingHorizontal: 16,
    alignSelf: "stretch",
    justifyContent: "center",
    height: 76
  },
  footerItem: {
    paddingHorizontal: 6,
    flex: 1
  },
  icon: {
    width: 14,
    height: 14
  },
  label: {
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium,
    fontSize: 16,
    lineHeight: 20
  },
  emptyText: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.grayText */.wL.grayText,
    marginTop: 16
  }
});
/* harmony default export */ var BookingModal_BookingContainer = (BookingContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/BookingModal/index.js


function BookingModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BookingModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BookingModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BookingModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var BookingModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, BookingModal_objectSpread(BookingModal_objectSpread({
    ref: ref
  }, props), {}, {
    modalType: config/* Constants.modalType.MODAL_TYPE_CENTER */.gT.modalType.MODAL_TYPE_CENTER,
    closableWithOutsideTouch: true // hideClose
    ,
    title: t("key_modal_title_booking"),
    icon: config/* Images.iconTicket */.rU.iconTicket,
    iconWidth: isMobileVersion ? 20 : 28,
    iconHeight: isMobileVersion ? 20 : 28,
    iconStyle: isMobileVersion ? null : {
      marginTop: -2
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(BookingModal_BookingContainer, BookingModal_objectSpread(BookingModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction,
      isMobileVersion: isMobileVersion
    }))
  }));
});
/* harmony default export */ var modals_BookingModal = (BookingModal);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Linking/index.js
var Linking = __webpack_require__(98346);
var Linking_default = /*#__PURE__*/__webpack_require__.n(Linking);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/Alert/index.js
var Alert = __webpack_require__(7426);
var Alert_default = /*#__PURE__*/__webpack_require__.n(Alert);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ReportMistakeModal/ReportMistakeContainer.js
/* provided dependency */ var process = __webpack_require__(83454);













var ReportMistakeContainer = function ReportMistakeContainer(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onOpenLink = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(url) {
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setTimeout( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
                var supported;
                return regenerator_default().wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return Linking_default().canOpenURL(url);

                      case 2:
                        supported = _context.sent;

                        if (!supported) {
                          _context.next = 8;
                          break;
                        }

                        _context.next = 6;
                        return Linking_default().openURL(url);

                      case 6:
                        _context.next = 9;
                        break;

                      case 8:
                        Alert_default().alert("Don't know how to open this URL: ".concat(url));

                      case 9:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              })), 400);

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onOpenLink(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [ReportMistakeContainer_styles.container, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: ReportMistakeContainer_styles.contentContainer,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
        style: [ReportMistakeContainer_styles.text, isMobileVersion ? {
          fontSize: 12
        } : {}],
        onPress: function onPress() {
          return onOpenLink("mailto:report.mistake@".concat(process.env.NEXT_PUBLIC__BASE_URL));
        },
        children: "report.mistake@supervybe.com"
      })
    })
  });
};

var ReportMistakeContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  contentContainer: {
    paddingVertical: 16,
    alignSelf: "stretch"
  },
  text: {
    textAlign: "center",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    color: (0,formatHelpers/* getClass */.ll)("text-white")
  }
});
/* harmony default export */ var ReportMistakeModal_ReportMistakeContainer = (ReportMistakeContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ReportMistakeModal/index.js


function ReportMistakeModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ReportMistakeModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ReportMistakeModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ReportMistakeModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ReportMistakeModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, ReportMistakeModal_objectSpread(ReportMistakeModal_objectSpread({
    ref: ref
  }, props), {}, {
    title: t('key_report_mistake'),
    icon: config/* Images.iconEdit */.rU.iconEdit,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ReportMistakeModal_ReportMistakeContainer, ReportMistakeModal_objectSpread(ReportMistakeModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction
    }))
  }));
});
/* harmony default export */ var modals_ReportMistakeModal = (ReportMistakeModal);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ShareModal/ShareContainer.js












var ShareContainer = function ShareContainer(props) {
  var _window$location$href;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var textAreaRef = (0,react.useRef)(null);
  var isMobileVersion = props.isMobileVersion;
  var _props$item = props.item,
      id = _props$item.id,
      profileId = _props$item.profileId,
      title = _props$item.title,
      displayName = _props$item.displayName,
      privacy = _props$item.privacy;
  var currentURL = (_window$location$href = window.location.href) === null || _window$location$href === void 0 ? void 0 : _window$location$href.replace("http://localhost:3000", "https://".concat("www.cocktayl.co"));
  var socialLinks = [{
    icon: config/* Images.iconFacebookLinkCircle */.rU.iconFacebookLinkCircle,
    alt: "facebook",
    url: "https://www.facebook.com/sharer/sharer.php?u=".concat(currentURL)
  }, {
    icon: config/* Images.iconTwitterLinkCircle */.rU.iconTwitterLinkCircle,
    alt: "twitter",
    url: "https://twitter.com/intent/tweet?text=".concat(title || displayName, "&url=").concat(currentURL)
  }, {
    icon: config/* Images.iconWhatsappCircle */.rU.iconWhatsappCircle,
    alt: "whatsapp",
    url: "https://api.whatsapp.com/send?text=".concat(title || displayName, " ").concat(currentURL)
  }, {
    icon: config/* Images.iconGmailCircle */.rU.iconGmailCircle,
    alt: "email",
    url: "mailto:?body=".concat(currentURL, "&subject=").concat(title || displayName)
  }, {
    icon: config/* Images.iconLinkedinCircle */.rU.iconLinkedinCircle,
    alt: "linkedin",
    url: "https://www.linkedin.com/shareArticle/?mini=true&url=".concat(currentURL, "&title=").concat("Cocktayl", "&summary=").concat(title || displayName)
  }, {
    icon: config/* Images.iconLinkCircle */.rU.iconLinkCircle,
    alt: "copy",
    url: "copy"
  }];

  var onButtonAction = function onButtonAction(actionType) {
    if (props.onButtonAction) {
      props.onButtonAction({
        modalType: config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT,
        actionType: actionType
      });
    }
  };

  var onOpenLink = function onOpenLink(url) {
    var win = window.open(url, "_blank");
    win.focus();
  };

  var copyTextToClipboard = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              textAreaRef.current.select();
              document.execCommand("copy"); // if ("clipboard" in navigator) {
              //   return await navigator.clipboard.writeText(text);
              // } else {
              //   return document.execCommand("copy", true, text);
              // }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function copyTextToClipboard(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var renderSocialLinkItem = function renderSocialLinkItem(item, index, totalCount) {
    var url = item.url,
        alt = item.alt,
        icon = item.icon;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
      style: [ShareContainer_styles.socialLinkIcon, {
        flex: 1,
        alignItems: "center",
        marginVertical: 10
      }],
      onPress: function onPress() {
        if (url === "copy") {
          copyTextToClipboard();
        } else {
          onOpenLink(url);
        }

        onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        width: 40,
        height: 40,
        layout: "fixed",
        source: icon,
        style: ShareContainer_styles.socialLinkIcon,
        resizeMode: "contain",
        alt: alt
      })
    }, index + "social-link");
  };

  var renderSocialItems = function renderSocialItems(socialItems) {
    var totalCount = socialItems.length;
    return socialItems.map(function (socialItem, index) {
      return renderSocialLinkItem(socialItem, index, totalCount);
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [ShareContainer_styles.container, props.style],
    children: [socialLinks.length > 0 && privacy !== config/* Constants.privacyType.private */.gT.privacyType["private"] && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: [ShareContainer_styles.footerButton, {
        borderWidth: 0,
        marginTop: 16,
        flexWrap: "wrap",
        justifyContent: "flex-start",
        height: "auto"
      }],
      children: renderSocialItems(socialLinks)
    }), privacy === config/* Constants.privacyType.private */.gT.privacyType["private"] && /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: ShareContainer_styles.footerButton,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
        buttonTitle: t("key_close"),
        style: [ShareContainer_styles.buttonStyle, {
          marginBottom: 16,
          width: "100%",
          paddingHorizontal: 20
        }],
        filled: true,
        onPress: /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
          return regenerator_default().wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  onButtonAction(config/* Constants.actionType.ACTION_CLOSE */.gT.actionType.ACTION_CLOSE);

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }))
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
      ref: textAreaRef,
      value: window.location.href,
      className: "opacity-0 absolute top-0 left-0",
      readOnly: true
    })]
  });
};

var ShareContainer_styles = StyleSheet_default().create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch"
  },
  rowContainer: {
    alignItems: "center",
    flexDirection: "row"
  },
  contentContainer: {
    paddingTop: 20,
    paddingBottom: 16,
    alignSelf: "stretch",
    alignItems: "center"
  },
  text: {
    textAlign: "center",
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 14,
    color: config/* Colors.white */.wL.white
  },
  socialLinkIcon: {
    width: 40,
    height: 40
  },
  footerButton: {
    borderTopColor: config/* Colors.tabBottomColor */.wL.tabBottomColor,
    borderTopWidth: 1,
    flexDirection: "row",
    alignItems: "center",
    marginHorizontal: -16,
    paddingHorizontal: 16,
    alignSelf: "stretch",
    justifyContent: "center",
    height: 76
  },
  footerItem: {
    paddingHorizontal: 6,
    flex: 1
  },
  icon: {
    width: 14,
    height: 14
  },
  label: {
    color: config/* Colors.white */.wL.white,
    fontFamily: config/* Fonts.primaryMedium */.F3.primaryMedium,
    fontSize: 16,
    lineHeight: 20
  },
  emptyText: {
    fontSize: 18,
    lineHeight: 22,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    color: config/* Colors.grayText */.wL.grayText,
    marginTop: 16
  }
});
/* harmony default export */ var ShareModal_ShareContainer = (ShareContainer);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ShareModal/index.js


function ShareModal_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ShareModal_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ShareModal_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ShareModal_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ShareModal = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var onButtonAction = function onButtonAction(data) {
    if (props.onButtonAction) {
      props.onButtonAction(data);
    }

    if (ref) {
      ref.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CModal */.Tk, ShareModal_objectSpread(ShareModal_objectSpread({
    ref: ref
  }, props), {}, {
    modalType: config/* Constants.modalType.MODAL_TYPE_CENTER */.gT.modalType.MODAL_TYPE_CENTER,
    closableWithOutsideTouch: true // hideClose
    ,
    title: t("key_modal_title_share"),
    icon: config/* Images.iconShareColored */.rU.iconShareColored,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShareModal_ShareContainer, ShareModal_objectSpread(ShareModal_objectSpread({}, props), {}, {
      onButtonAction: onButtonAction,
      isMobileVersion: isMobileVersion
    }))
  }));
});
/* harmony default export */ var modals_ShareModal = (ShareModal);
;// CONCATENATED MODULE: ./src/modules/profile/modals/ProfileModalContainer.js



 // import ReportModalContainer from "../../../components/molecules/ReportModal";





 // import AddTicketLinkModal from "./AddTicketLinkModal";
// import ReportSuccessModal from "../../../components/molecules/ReportModal/modals/ReportSuccessModal";
// import AddToCalendarModal from "./AddToCalendarModal";



var ProfileModalContainer = /*#__PURE__*/react.forwardRef(function (props, ref) {
  var idProfileModalRef = (0,react.useRef)(null);
  var reportModalRef = (0,react.useRef)(null);
  var contactModalRef = (0,react.useRef)(null);
  var calendarModalRef = (0,react.useRef)(null);
  var bookingModalRef = (0,react.useRef)(null);
  var reportMistakeModalRef = (0,react.useRef)(null);
  var shareModalRef = (0,react.useRef)(null);
  var addTicketModalRef = (0,react.useRef)(null);
  var reportSuccessRef = (0,react.useRef)(null);
  var addToCalendarModalRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)({}),
      data = _useState[0],
      setData = _useState[1];

  var item = props.item,
      category = props.category,
      isMobileVersion = props.isMobileVersion;
  var contact = item ? item.contact : null;
  (0,react.useImperativeHandle)(ref, function () {
    return {
      showModal: onShowModal,
      hideModal: onHideModal
    };
  });

  var onShowModal = function onShowModal(modalType) {
    var _data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_ID_PROFILE */.gT.profileModalType.PROFILE_MODAL_ID_PROFILE) {
      idProfileModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_REPORT */.gT.profileModalType.PROFILE_MODAL_REPORT) {
      if (_data) {
        setData(_data);
      }

      reportModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT) {
      contactModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_CALENDAR */.gT.profileModalType.PROFILE_MODAL_CALENDAR) {
      calendarModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_BOOKING */.gT.profileModalType.PROFILE_MODAL_BOOKING) {
      bookingModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_REPORT_MISTAKE */.gT.profileModalType.PROFILE_MODAL_REPORT_MISTAKE) {
      reportMistakeModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE) {
      shareModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_ADD_TICKET_LINK */.gT.profileModalType.PROFILE_MODAL_ADD_TICKET_LINK) {
      addTicketModalRef.current.showModal();
    }

    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_ADD_TO_CALENDAR */.gT.profileModalType.PROFILE_MODAL_ADD_TO_CALENDAR) {
      addToCalendarModalRef.current.showModal();
    }
  };

  var onHideModal = function onHideModal(modalType) {
    if (modalType == config/* Constants.profileModalType.PROFILE_MODAL_ID_PROFILE */.gT.profileModalType.PROFILE_MODAL_ID_PROFILE) {
      idProfileModalRef.current.hideModal();
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(modals_IDProfileModal, {
      ref: idProfileModalRef,
      item: item,
      category: category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ReportMistakeModal, {
      ref: reportMistakeModalRef,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ContactModal, {
      ref: contactModalRef,
      item: item,
      contact: contact,
      category: category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_CalendarModal, {
      ref: calendarModalRef,
      item: item,
      category: category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_BookingModal, {
      ref: bookingModalRef,
      item: item,
      contact: contact,
      category: category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ShareModal, {
      ref: shareModalRef,
      item: item,
      isMobileVersion: isMobileVersion
    })]
  });
});
/* harmony default export */ var modals_ProfileModalContainer = (ProfileModalContainer);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-web-share/dist/esm/index.js
var esm = __webpack_require__(80521);
;// CONCATENATED MODULE: ./src/modules/profile/components/ProfileBottomMenuBar.js


var _objectSpread2;

function ProfileBottomMenuBar_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ProfileBottomMenuBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ProfileBottomMenuBar_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ProfileBottomMenuBar_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }













var ProfileBottomMenuBar = function ProfileBottomMenuBar(props) {
  var isFloating = true;
  var profile = props.profile,
      category = props.category,
      isMobileVersion = props.isMobileVersion,
      hideContact = props.hideContact,
      hideShare = props.hideShare;
  var title = (profile === null || profile === void 0 ? void 0 : profile.title) || (profile === null || profile === void 0 ? void 0 : profile.displayName) || "";

  var renderButton = function renderButton() {
    if (props.renderButton) {
      return props.renderButton();
    }

    return null;
  };

  var renderMagicButton = function renderMagicButton() {
    if (props.renderMagicButton) {
      return props.renderMagicButton();
    }

    return null;
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: [{
      height: isMobileVersion ? 62 : 80,
      marginTop: -30,
      justifyContent: "space-between",
      flexDirection: "row",
      maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
      width: "100%",
      alignSelf: "center",
      paddingHorizontal: 30,
      borderTopLeftRadius: isMobileVersion ? 25 : 40,
      borderTopRightRadius: isMobileVersion ? 25 : 40,
      alignItems: "center",
      backgroundColor: (0,formatHelpers/* getClass */.ll)("footer"),
      filter: "drop-shadow(0px -2px 15px rgba(0, 0, 0, 0.5))"
    }, isFloating && {
      position: "fixed",
      bottom: 0
    }],
    children: [renderButton(), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: {
        flexDirection: "row",
        alignItems: "center",
        marginLeft: isMobileVersion && category !== config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? hideContact ? 0 : 8 : 0
      },
      children: [!hideContact && /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
        onPress: function onPress() {
          if (props.onContactPress) {
            props.onContactPress();
          }
        },
        style: [ProfileBottomMenuBar_styles.contactButton, isMobileVersion ? {
          marginRight: 8,
          height: 34,
          width: "auto"
        } : {}],
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          width: isMobileVersion ? 16 : 20,
          height: isMobileVersion ? 16 : 20,
          layout: "fixed",
          objectFit: "cover",
          source: config/* Images.iconChat */.rU.iconChat,
          alt: "contact"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: [ProfileBottomMenuBar_styles.contactButtonText, isMobileVersion ? {
            fontSize: 12
          } : {}, {
            textTransform: "uppercase"
          }],
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
            children: "Contact"
          })
        })]
      }), !hideShare && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        style: ProfileBottomMenuBar_objectSpread(ProfileBottomMenuBar_objectSpread({
          display: "flex"
        }, (0,formatHelpers/* getClass */.ll)("btn-border2")), {}, {
          borderRadius: 20,
          alignItems: "center",
          justifyContent: "center",
          width: isMobileVersion ? 32 : 40,
          height: isMobileVersion ? 32 : 40,
          marginRight: isMobileVersion ? 0 : 15
        }),
        onPress: function onPress() {
          if (props.onSharePress) {
            props.onSharePress();
          }
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          width: isMobileVersion ? 16 : 24,
          height: isMobileVersion ? 16 : 24,
          layout: "fixed",
          objectFit: "cover",
          source: config/* Images.iconShare */.rU.iconShare,
          style: {
            width: 24,
            height: 24
          },
          alt: "share"
        })
      }), !isMobileVersion && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        onPress: function onPress() {
          if (props.onMorePress) {
            props.onMorePress();
          }
        },
        style: ProfileBottomMenuBar_styles.moreButton,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          width: 24,
          height: 24,
          layout: "fixed",
          objectFit: "cover",
          source: config/* Images.iconMore */.rU.iconMore,
          style: {
            width: 24,
            height: 24
          },
          alt: "more menu"
        })
      })]
    })]
  });
};

var ProfileBottomMenuBar_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch"
  },
  moreButton: ProfileBottomMenuBar_objectSpread(ProfileBottomMenuBar_objectSpread({}, (0,formatHelpers/* getClass */.ll)("btn-border2")), {}, {
    borderRadius: 20,
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40
  }),
  contactButton: ProfileBottomMenuBar_objectSpread(ProfileBottomMenuBar_objectSpread({}, (0,formatHelpers/* getClass */.ll)("btn-border2")), {}, (_objectSpread2 = {
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
    height: 40,
    flexDirection: "row"
  }, (0,defineProperty/* default */.Z)(_objectSpread2, "alignItems", "center"), (0,defineProperty/* default */.Z)(_objectSpread2, "marginRight", 15), (0,defineProperty/* default */.Z)(_objectSpread2, "width", 210), _objectSpread2)),
  contactButtonText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 20,
    color: (0,formatHelpers/* getClass */.ll)("text-white"),
    textAlign: "center",
    marginLeft: 5
  }
});
/* harmony default export */ var components_ProfileBottomMenuBar = (ProfileBottomMenuBar);
// EXTERNAL MODULE: ./helpers/index.js
var helpers_0 = __webpack_require__(60651);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/modules/profile/event/views/EventProfileView.js























var PAGE_WIDTH = 1070;

var EventProfileView = function EventProfileView(props) {
  var _props$event4, _photos, _props$event5, _props$event6, _props$event7, _props$event8, _props$event9, _props$event10, _props$event11, _props$event12, _props$event13, _props$event14, _props$event15, _props$event16, _props$event17, _props$event18, _props$event19, _props$event20, _props$event21, _props$event22, _props$event23, _props$event24, _props$event25, _props$event26, _props$event27, _props$event27$descri, _props$event28, _props$event29, _props$event30, _props$lineup, _props$event31, _props$event32, _props$event33, _props$event34, _props$event35, _props$event35$descri, _props$event36, _props$event37, _props$event38, _props$event39, _props$event40, _props$event41, _props$event42, _props$event43, _props$event44, _props$event45, _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _props$event46, _props$event47, _props$event48, _props$event49, _props$event50, _props$event51, _props$event51$photos, _props$event52, _props$event53, _props$event54, _props$event55, _props$event56, _props$event56$photos, _props$event57;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var modalRef = (0,react.useRef)(null);
  var navigation = (0,router.useRouter)();

  var _useState = (0,react.useState)(false),
      isShowMenu = _useState[0],
      setIsShowMenu = _useState[1];

  var tabType = props.tabType,
      subTabType = props.subTabType,
      isMobileVersion = props.isMobileVersion;

  var _useState2 = (0,react.useState)(false),
      isReady = _useState2[0],
      setIsReady = _useState2[1];

  var _useState3 = (0,react.useState)(0),
      activeIndex = _useState3[0],
      setActiveIndex = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isShowMenuMagic = _useState4[0],
      setIsShowMenuMagic = _useState4[1];

  var itemsOther = isMobileVersion ? [{
    id: 12,
    title: t("key_report_mistake"),
    icon: config/* Images.iconEdit */.rU.iconEdit,
    type: config/* Constants.profileMenuType.PROFILE_MENU_REPORT_MISTAKE */.gT.profileMenuType.PROFILE_MENU_REPORT_MISTAKE
  }, {
    id: 3,
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    type: config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE
  }, {
    id: 13,
    title: t("key_modal_title_share"),
    icon: config/* Images.iconShareColored */.rU.iconShareColored,
    type: config/* Constants.profileMenuType.PROFILE_MENU_SHARE */.gT.profileMenuType.PROFILE_MENU_SHARE
  }] : [{
    id: 12,
    title: t("key_report_mistake"),
    icon: config/* Images.iconEdit */.rU.iconEdit,
    type: config/* Constants.profileMenuType.PROFILE_MENU_REPORT_MISTAKE */.gT.profileMenuType.PROFILE_MENU_REPORT_MISTAKE
  }, {
    id: 3,
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    type: config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE
  }];
  var itemsMagic = [{
    id: 11,
    title: t("key_add_to_edition"),
    icon: config/* Images.iconDateColored */.rU.iconDateColored,
    type: config/* Constants.profileMenuType.PROFILE_MENU_EDITION */.gT.profileMenuType.PROFILE_MENU_EDITION
  } // {
  //   id: 7,
  //   title: t("key_insights"),
  //   icon: Images.iconInsight,
  //   type: Constants.profileMenuType.PROFILE_MENU_INSIGHTS,
  // },
  ];

  var onOpenExternalLink = function onOpenExternalLink(url) {
    var win = window.open(url, "_blank");
    win.focus();
  };

  var onPressMenuItem = function onPressMenuItem(item) {
    if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_EDITION */.gT.profileMenuType.PROFILE_MENU_EDITION) {
      var _props$event, _props$event2, _props$event3;

      navigation.push("".concat((0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$event = props.event) === null || _props$event === void 0 ? void 0 : _props$event.id, props === null || props === void 0 ? void 0 : (_props$event2 = props.event) === null || _props$event2 === void 0 ? void 0 : _props$event2.title, props === null || props === void 0 ? void 0 : (_props$event3 = props.event) === null || _props$event3 === void 0 ? void 0 : _props$event3.startDate, props.category, "edition")));
    }

    if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ID_PROFILE */.gT.profileModalType.PROFILE_MODAL_ID_PROFILE);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_REPORT */.gT.profileMenuType.PROFILE_MENU_REPORT) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_REPORT */.gT.profileModalType.PROFILE_MODAL_REPORT, {
        reportCategory: config/* Constants.reportCategory.REPORT_FESTIVAL */.gT.reportCategory.REPORT_FESTIVAL
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_UPDATE */.gT.profileMenuType.PROFILE_MENU_UPDATE) {
      navigation.navigate("EventUpdateScreen", {
        eventId: props.event.id
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_CONTACT_HOST */.gT.profileMenuType.PROFILE_MENU_CONTACT_HOST) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_TICKET_LINK */.gT.profileMenuType.PROFILE_MENU_TICKET_LINK) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ADD_TICKET_LINK */.gT.profileModalType.PROFILE_MODAL_ADD_TICKET_LINK);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_CALENDAR */.gT.profileMenuType.PROFILE_MENU_CALENDAR) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ADD_TO_CALENDAR */.gT.profileModalType.PROFILE_MODAL_ADD_TO_CALENDAR);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_INSIGHTS */.gT.profileMenuType.PROFILE_MENU_INSIGHTS) {
      navigation.push({
        pathname: "/profile/insight",
        query: {
          id: props.event.id,
          profileId: props.event.profileId
        }
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_REPORT_MISTAKE */.gT.profileMenuType.PROFILE_MENU_REPORT_MISTAKE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_REPORT_MISTAKE */.gT.profileModalType.PROFILE_MODAL_REPORT_MISTAKE);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_SHARE */.gT.profileMenuType.PROFILE_MENU_SHARE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE);
    }
  };

  var onChangeIsShown = function onChangeIsShown(flag) {
    setIsShowMenu(flag);
  };

  var photos = props === null || props === void 0 ? void 0 : (_props$event4 = props.event) === null || _props$event4 === void 0 ? void 0 : _props$event4.photos;

  if (photos && !Array.isArray(photos)) {
    photos = JSON.parse(photos);
  }

  var backgroundImage = ((_photos = photos) === null || _photos === void 0 ? void 0 : _photos.length) > 0 ? photos[0].url : "Local:imagePlaceholder";
  (0,react.useEffect)(function () {
    setIsReady(true);
  }, []);
  var item = props === null || props === void 0 ? void 0 : props.event;
  var id = item === null || item === void 0 ? void 0 : item.id;
  var title = item === null || item === void 0 ? void 0 : item.title;
  var startDate = item === null || item === void 0 ? void 0 : item.startDate;
  var slug = (0,helpers_0/* getSlugFromName */.g_)(title, startDate);
  var canonicalURL = "https://".concat("www.cocktayl.co").concat((0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$event5 = props.event) === null || _props$event5 === void 0 ? void 0 : _props$event5.id, props === null || props === void 0 ? void 0 : (_props$event6 = props.event) === null || _props$event6 === void 0 ? void 0 : _props$event6.title, props === null || props === void 0 ? void 0 : props.event.startDate, props.category, tabType === "about" ? "about" : "about#".concat(tabType)));
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: EventProfileView_styles.container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@graph": [{
              "@context": "https://schema.org",
              "@type": "Event",
              "@id": canonicalURL,
              url: canonicalURL,
              name: props === null || props === void 0 ? void 0 : (_props$event7 = props.event) === null || _props$event7 === void 0 ? void 0 : _props$event7.title,
              startDate: moment_default()(props === null || props === void 0 ? void 0 : (_props$event8 = props.event) === null || _props$event8 === void 0 ? void 0 : _props$event8.startDate).format("YYYY-MM-DD"),
              endDate: moment_default()(props === null || props === void 0 ? void 0 : (_props$event9 = props.event) === null || _props$event9 === void 0 ? void 0 : _props$event9.endDate).format("YYYY-MM-DD"),
              eventAttendanceMode: props !== null && props !== void 0 && (_props$event10 = props.event) !== null && _props$event10 !== void 0 && _props$event10.isVirtual ? "https://schema.org/OnlineEventAttendanceMode" : "https://schema.org/OfflineEventAttendanceMode",
              eventStatus: (props === null || props === void 0 ? void 0 : (_props$event11 = props.event) === null || _props$event11 === void 0 ? void 0 : _props$event11.status) === config/* Constants.festivalStatus.FE_STAT_UPCOMMING_CONFIRMED */.gT.festivalStatus.FE_STAT_UPCOMMING_CONFIRMED || (props === null || props === void 0 ? void 0 : (_props$event12 = props.event) === null || _props$event12 === void 0 ? void 0 : _props$event12.status) === config/* Constants.festivalStatus.FE_STAT_UPCOMMING_LIVE */.gT.festivalStatus.FE_STAT_UPCOMMING_LIVE ? "https://schema.org/EventScheduled" : (props === null || props === void 0 ? void 0 : (_props$event13 = props.event) === null || _props$event13 === void 0 ? void 0 : _props$event13.status) === config/* Constants.festivalStatus.FE_STAT_UPCOMMING_CANCELED */.gT.festivalStatus.FE_STAT_UPCOMMING_CANCELED ? "https://schema.org/EventScheduled" : config/* Constants.festivalStatus.FE_STAT_RESCHEDULE_TO_BE_UPDATED */.gT.festivalStatus.FE_STAT_RESCHEDULE_TO_BE_UPDATED ? "https://schema.org/EventRescheduled" : config/* Constants.festivalStatus.FE_STAT_UPCOMMING_TO_BE_UPDATED */.gT.festivalStatus.FE_STAT_UPCOMMING_TO_BE_UPDATED ? "https://schema.org/ventPostponed" : "https://schema.org/EventScheduled",
              location: props !== null && props !== void 0 && (_props$event14 = props.event) !== null && _props$event14 !== void 0 && _props$event14.isVirtual ? {
                "@type": "VirtualLocation",
                url: props === null || props === void 0 ? void 0 : (_props$event15 = props.event) === null || _props$event15 === void 0 ? void 0 : _props$event15.infoLinkUrl
              } : {
                "@type": "Place",
                name: (props === null || props === void 0 ? void 0 : (_props$event16 = props.event) === null || _props$event16 === void 0 ? void 0 : _props$event16.venue) || (props === null || props === void 0 ? void 0 : (_props$event17 = props.event) === null || _props$event17 === void 0 ? void 0 : _props$event17.address) || (props !== null && props !== void 0 && (_props$event18 = props.event) !== null && _props$event18 !== void 0 && _props$event18.city ? "".concat(props === null || props === void 0 ? void 0 : (_props$event19 = props.event) === null || _props$event19 === void 0 ? void 0 : _props$event19.city, ", ").concat(props === null || props === void 0 ? void 0 : (_props$event20 = props.event) === null || _props$event20 === void 0 ? void 0 : _props$event20.nationality) : props === null || props === void 0 ? void 0 : (_props$event21 = props.event) === null || _props$event21 === void 0 ? void 0 : _props$event21.nationality),
                address: {
                  "@type": "PostalAddress",
                  streetAddress: props === null || props === void 0 ? void 0 : (_props$event22 = props.event) === null || _props$event22 === void 0 ? void 0 : _props$event22.address,
                  addressLocality: props === null || props === void 0 ? void 0 : (_props$event23 = props.event) === null || _props$event23 === void 0 ? void 0 : _props$event23.stateName,
                  addressRegion: props === null || props === void 0 ? void 0 : (_props$event24 = props.event) === null || _props$event24 === void 0 ? void 0 : _props$event24.stateCode,
                  addressCountry: props === null || props === void 0 ? void 0 : (_props$event25 = props.event) === null || _props$event25 === void 0 ? void 0 : _props$event25.countryCode
                }
              },
              image: [props === null || props === void 0 ? void 0 : (_props$event26 = props.event) === null || _props$event26 === void 0 ? void 0 : _props$event26.avatar].filter(function (i) {
                return i !== null;
              }).map(function (i) {
                return {
                  "@id": i
                };
              }),
              description: props === null || props === void 0 ? void 0 : (_props$event27 = props.event) === null || _props$event27 === void 0 ? void 0 : (_props$event27$descri = _props$event27.description) === null || _props$event27$descri === void 0 ? void 0 : _props$event27$descri.replace(/(<([^>]+)>)/gi, ""),
              offers: {
                "@type": "Offer",
                url: "/".concat(props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? "festivals" : "events", "/").concat((0,helpers_0/* getSlugFromName */.g_)(props === null || props === void 0 ? void 0 : (_props$event28 = props.event) === null || _props$event28 === void 0 ? void 0 : _props$event28.title, props === null || props === void 0 ? void 0 : (_props$event29 = props.event) === null || _props$event29 === void 0 ? void 0 : _props$event29.startDate), "/").concat(props === null || props === void 0 ? void 0 : (_props$event30 = props.event) === null || _props$event30 === void 0 ? void 0 : _props$event30.id, "/tickets"),
                availability: "https://schema.org/InStock"
              },
              performer: props === null || props === void 0 ? void 0 : (_props$lineup = props.lineup) === null || _props$lineup === void 0 ? void 0 : _props$lineup.map(function (item) {
                return {
                  "@type": "Person",
                  name: item.displayName
                };
              })
            }, {
              "@context": "https://schema.org",
              "@type": "WebPage",
              "@id": canonicalURL,
              url: canonicalURL,
              name: props === null || props === void 0 ? void 0 : (_props$event31 = props.event) === null || _props$event31 === void 0 ? void 0 : _props$event31.title,
              datePublished: props === null || props === void 0 ? void 0 : (_props$event32 = props.event) === null || _props$event32 === void 0 ? void 0 : _props$event32.createdAt,
              dateModified: props === null || props === void 0 ? void 0 : (_props$event33 = props.event) === null || _props$event33 === void 0 ? void 0 : _props$event33.updatedAt,
              image: [props === null || props === void 0 ? void 0 : (_props$event34 = props.event) === null || _props$event34 === void 0 ? void 0 : _props$event34.avatar].filter(function (i) {
                return i !== null;
              }).map(function (i) {
                return {
                  "@id": i
                };
              }),
              description: props === null || props === void 0 ? void 0 : (_props$event35 = props.event) === null || _props$event35 === void 0 ? void 0 : (_props$event35$descri = _props$event35.description) === null || _props$event35$descri === void 0 ? void 0 : _props$event35$descri.replace(/(<([^>]+)>)/gi, "")
            }]
          })
        }
      }, "structured-data")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: "".concat(props === null || props === void 0 ? void 0 : (_props$event36 = props.event) === null || _props$event36 === void 0 ? void 0 : _props$event36.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event37 = props.event) === null || _props$event37 === void 0 ? void 0 : _props$event37.startDate).format("YYYY")).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
      description: "Discover ".concat(props === null || props === void 0 ? void 0 : (_props$event38 = props.event) === null || _props$event38 === void 0 ? void 0 : _props$event38.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event39 = props.event) === null || _props$event39 === void 0 ? void 0 : _props$event39.startDate).format("YYYY"), " ").concat(tabType === "media" ? "media gallery on ".concat("Cocktayl", ".") : tabType === "wall" ? "community on ".concat("Cocktayl", " - posts about info, news and much more.") : tabType === "memories" ? "reviews on ".concat("Cocktayl", ".") : tabType === "lineup" ? "lineup on ".concat("Cocktayl", " - artists, poster and much more.") : "profile on ".concat("Cocktayl", " - dates, venue, tickets, lineup and much more.") //else about
      ),
      canonical: canonicalURL,
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: canonicalURL,
        title: "".concat(props === null || props === void 0 ? void 0 : (_props$event40 = props.event) === null || _props$event40 === void 0 ? void 0 : _props$event40.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event41 = props.event) === null || _props$event41 === void 0 ? void 0 : _props$event41.startDate).format("YYYY")).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
        description: "Discover ".concat(props === null || props === void 0 ? void 0 : (_props$event42 = props.event) === null || _props$event42 === void 0 ? void 0 : _props$event42.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event43 = props.event) === null || _props$event43 === void 0 ? void 0 : _props$event43.startDate).format("YYYY"), " ").concat(tabType === "media" ? "media gallery on ".concat("Cocktayl", ".") : tabType === "wall" ? "community on ".concat("Cocktayl", " - posts about info, news and much more.") : tabType === "memories" ? "reviews on ".concat("Cocktayl", ".") : tabType === "lineup" ? "lineup on ".concat("Cocktayl", " - artists, poster and much more.") : "profile on ".concat("Cocktayl", " - dates, venue, tickets, lineup and much more.") //else about
        ),
        images: [{
          url: props !== null && props !== void 0 && (_props$event44 = props.event) !== null && _props$event44 !== void 0 && _props$event44.avatar ? props === null || props === void 0 ? void 0 : (_props$event45 = props.event) === null || _props$event45 === void 0 ? void 0 : _props$event45.avatar : "https://".concat("www.cocktayl.co", "/images/").concat( true ? ((_process$env$NEXT_PUB = "Cocktayl") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "image_placeholder_new.png"),
          width: 1200,
          height: 630,
          alt: "".concat(props === null || props === void 0 ? void 0 : (_props$event46 = props.event) === null || _props$event46 === void 0 ? void 0 : _props$event46.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event47 = props.event) === null || _props$event47 === void 0 ? void 0 : _props$event47.startDate).format("YYYY")).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
      contentContainerStyle: EventProfileView_styles.scrollView,
      children: [isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {},
        children: [isReady && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          objectFit: "fill",
          imgUrl: backgroundImage,
          alt: "".concat(props === null || props === void 0 ? void 0 : (_props$event48 = props.event) === null || _props$event48 === void 0 ? void 0 : _props$event48.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event49 = props.event) === null || _props$event49 === void 0 ? void 0 : _props$event49.startDate).format("YYYY"), " ", "Festival")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-white/2 absolute bottom-0 left-0 right-0 top-0",
          style: {
            backdropFilter: "blur(40px)"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileHeader["default"], {
          photos: props !== null && props !== void 0 && (_props$event50 = props.event) !== null && _props$event50 !== void 0 && _props$event50.photos && (props === null || props === void 0 ? void 0 : (_props$event51 = props.event) === null || _props$event51 === void 0 ? void 0 : (_props$event51$photos = _props$event51.photos) === null || _props$event51$photos === void 0 ? void 0 : _props$event51$photos.length) > 0 ? (props === null || props === void 0 ? void 0 : (_props$event52 = props.event) === null || _props$event52 === void 0 ? void 0 : _props$event52.photos) || [] : [{
            url: "Local:imagePlaceholder"
          }],
          activeIndex: activeIndex,
          setActiveIndex: setActiveIndex,
          items: itemsOther,
          event: props.event,
          isShowMenu: isShowMenu,
          onChangeIsShown: onChangeIsShown,
          onPressMenuItem: onPressMenuItem,
          style: {
            maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
            width: "100%",
            height: 239,
            marginBottom: 120,
            alignSelf: "center"
          },
          isMobileVersion: isMobileVersion,
          category: props.category
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          alignSelf: "stretch",
          height: 650
        },
        children: [isReady && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          objectFit: "fill",
          imgUrl: backgroundImage,
          alt: "".concat(props === null || props === void 0 ? void 0 : (_props$event53 = props.event) === null || _props$event53 === void 0 ? void 0 : _props$event53.title, " ").concat(moment_default()(props === null || props === void 0 ? void 0 : (_props$event54 = props.event) === null || _props$event54 === void 0 ? void 0 : _props$event54.startDate).format("YYYY"), " ", "Festival")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-white/2 absolute bottom-0 left-0 right-0 top-0",
          style: {
            backdropFilter: "blur(40px)"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileHeader["default"], {
          photos: props !== null && props !== void 0 && (_props$event55 = props.event) !== null && _props$event55 !== void 0 && _props$event55.photos && (props === null || props === void 0 ? void 0 : (_props$event56 = props.event) === null || _props$event56 === void 0 ? void 0 : (_props$event56$photos = _props$event56.photos) === null || _props$event56$photos === void 0 ? void 0 : _props$event56$photos.length) > 0 ? (props === null || props === void 0 ? void 0 : (_props$event57 = props.event) === null || _props$event57 === void 0 ? void 0 : _props$event57.photos) || [] : [{
            url: "Local:imagePlaceholder"
          }],
          activeIndex: activeIndex,
          setActiveIndex: setActiveIndex,
          items: itemsOther,
          event: props.event,
          isShowMenu: isShowMenu,
          onChangeIsShown: onChangeIsShown,
          onPressMenuItem: onPressMenuItem,
          customNavBar: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {}),
          style: {
            maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
            width: "100%",
            height: 530,
            marginBottom: 120,
            alignSelf: "center"
          },
          isMobileVersion: isMobileVersion,
          category: props.category
        })]
      }), isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_EventInfoView, {
        style: {
          borderTopLeftRadius: 25,
          borderTopRightRadius: 25,
          marginTop: -120
        },
        item: props.event,
        loadData: props.loadData,
        isMobileVersion: isMobileVersion
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_EventInfoView, {
        style: {
          borderTopLeftRadius: 120,
          borderTopRightRadius: 120,
          marginTop: -120
        },
        item: props.event,
        loadData: props.loadData,
        isMobileVersion: isMobileVersion
      }), isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileBottomView["default"], {
        style: {
          // marginTop: -25,
          maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
          width: "100%",
          alignSelf: "center"
        },
        item: props.event,
        category: props.category,
        isNested: true,
        initialTabType: tabType,
        subTabType: subTabType,
        isMobileVersion: isMobileVersion
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileBottomView["default"], {
        style: {
          marginTop: 20,
          maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
          width: "100%",
          alignSelf: "center"
        },
        item: props.event,
        category: props.category,
        isNested: true,
        initialTabType: tabType,
        subTabType: subTabType
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ProfileModalContainer, {
        ref: modalRef,
        item: props.event,
        category: props.category,
        isMobileVersion: isMobileVersion
      })]
    }), isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: [{
        height: isMobileVersion ? 62 : 80,
        marginTop: -30,
        justifyContent: "space-around",
        flexDirection: "row",
        maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
        width: "100%",
        alignSelf: "center",
        paddingHorizontal: 30,
        borderTopLeftRadius: isMobileVersion ? 25 : 40,
        borderTopRightRadius: isMobileVersion ? 25 : 40,
        alignItems: "center",
        backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
        filter: "drop-shadow(0px -2px 15px rgba(0, 0, 0, 0.5))",
        position: "fixed",
        bottom: 0
      }],
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/".concat(props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? "festivals" : "events", "/").concat(slug, "/").concat(id, "/tickets"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          style: {
            width: 23,
            height: 23
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
            source: config/* Images.iconTicketWhite */.rU.iconTicketWhite,
            width: 23,
            height: 23,
            layout: "fixed"
          })
        })
      }), props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        onPress: function onPress() {
          return setIsShowMenuMagic(true);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconMenuMagic */.rU.iconMenuMagic,
          width: 50,
          height: 50,
          layout: "fixed"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
        onPress: function onPress() {
          return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          source: config/* Images.iconChat */.rU.iconChat,
          width: 23,
          height: 23,
          layout: "fixed"
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_ProfileBottomMenuBar, {
      profile: props.event,
      isMobileVersion: isMobileVersion,
      category: props.category,
      onMorePress: function onMorePress() {
        setIsShowMenu(true);
      },
      onContactPress: function onContactPress() {
        return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
      },
      onSharePress: function onSharePress() {
        return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE);
      },
      renderMagicButton: function renderMagicButton() {
        if (props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
            onPress: function onPress() {
              return setIsShowMenuMagic(true);
            },
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              source: config/* Images.iconMenuMagic */.rU.iconMenuMagic,
              width: 60,
              height: 60,
              layout: "fixed"
            })
          });
        } else {
          return null;
        }
      },
      renderButton: function renderButton() {
        return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
            isHeading: true,
            buttonTitle: t("key_button_ticket"),
            icon: config/* Images.iconTicket */.rU.iconTicket,
            url: "/".concat(props.category === config/* Constants.categoryType.CATEGORY_FESTIVAL */.gT.categoryType.CATEGORY_FESTIVAL ? "festivals" : "events", "/").concat(slug, "/").concat(id, "/tickets"),
            filled: true,
            fontSize: isMobileVersion ? 12 : 16,
            iconStyle: {
              width: 20,
              height: 20
            },
            style: isMobileVersion ? {
              height: 32,
              width: "100%"
            } : {
              height: 40,
              width: 320
            },
            isMobileVersion: isMobileVersion
          })
        });
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* PopupMenuListModal */.Fl, {
      isVisible: isShowMenuMagic,
      onClose: function onClose() {
        setIsShowMenuMagic(false);
      },
      onPressItem: onPressMenuItem,
      items: itemsMagic,
      isMobileVersion: isMobileVersion,
      category: props.category
    })]
  });
};

var EventProfileView_styles = StyleSheet_default().create({
  container: {
    flex: 1,
    backgroundColor: config/* Colors.black */.wL.black,
    marginBottom: 0
  },
  bottomContainer: {
    height: 90,
    alignSelf: "stretch",
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    marginBottom: 50,
    paddingHorizontal: 30,
    justifyContent: "center"
  },
  scrollView: {
    flexGrow: 1,
    flexDirection: "column"
  },
  moreButton: {
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    borderRadius: 20,
    padding: 5
  }
});
/* harmony default export */ var views_EventProfileView = (EventProfileView);
// EXTERNAL MODULE: ./src/DAO/index.js + 12 modules
var DAO = __webpack_require__(90793);
;// CONCATENATED MODULE: ./src/modules/profile/event/containers/EventProfileViewContainer.js





var EventProfileViewContainer = function EventProfileViewContainer(props) {
  var id = props.id,
      profileId = props.profileId,
      tabType = props.tabType,
      subTabType = props.subTabType,
      item = props.item,
      lineup = props.lineup;

  var _useState = (0,react.useState)(item),
      detail = _useState[0],
      setDetail = _useState[1];

  var loadData = function loadData() {
    if (id) {
      DAO/* EventDao.findOne */.SA.findOne(id).then(function (result) {
        setDetail(result);
      });
    } else if (profileId) {
      DAO/* EventDao.findOneByProfileId */.SA.findOneByProfileId(profileId).then(function (result) {
        setDetail(result);
      });
    }
  };

  (0,react.useEffect)(function () {
    loadData();
  }, [props.category, props.id, props.profileId]);
  return item ? /*#__PURE__*/(0,jsx_runtime.jsx)(views_EventProfileView, {
    event: item,
    lineup: lineup,
    loadData: loadData,
    tabType: tabType,
    subTabType: subTabType,
    category: props.category,
    isMobileVersion: props.isMobileVersion
  }) : null;
};

/* harmony default export */ var containers_EventProfileViewContainer = (EventProfileViewContainer);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/modules/profile/artist/components/ArtistInfoView.js













var ArtistInfoView_CAvatar = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 19165));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(19165)];
    }
  }
});

var ArtistInfoView = function ArtistInfoView(props) {
  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var isMobileVersion = props.isMobileVersion;

  var _useState = (0,react.useState)(false),
      isReady = _useState[0],
      setIsReady = _useState[1];

  var alertModalGenreRef = (0,react.useRef)(null);
  var alertModalLocationRef = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setIsReady(true);
  }, []);
  if (!props.item || !isReady) return null;
  var _props$item = props.item,
      id = _props$item.id,
      isFollow = _props$item.isFollow,
      profileId = _props$item.profileId,
      isVirtual = _props$item.isVirtual,
      isInPerson = _props$item.isInPerson,
      title = _props$item.title,
      location = _props$item.location,
      startDate = _props$item.startDate,
      periodString = _props$item.periodString,
      totalFollower = _props$item.totalFollower,
      totalFollowing = _props$item.totalFollowing,
      totalConnection = _props$item.totalConnection,
      avatar = _props$item.avatar,
      displayName = _props$item.displayName,
      username = _props$item.username,
      rating = _props$item.rating,
      userType = _props$item.userType,
      activity = _props$item.activity,
      bio = _props$item.bio,
      nationality = _props$item.nationality,
      genres = _props$item.genres;
  var genreItems = [];

  if (genres) {
    genreItems = genres;
  }

  var userTypeName = "Artist";
  var genreName = genreItems.length > 0 ? genreItems[0].title : null;
  var moreGenre = genreItems.length > 1 ? "+" + (genreItems.length - 1) : null;
  var fullGenreNames = genreItems.map(function (genreItem) {
    return genreItem.title;
  }).join(", ");
  var artistTypeTexts = [userTypeName];
  var isInTour = activity == config/* Constants.artistActivity.ACTIVITY_IN_TOUR */.gT.artistActivity.ACTIVITY_IN_TOUR;

  if (isInTour) {
    artistTypeTexts.push(t("key_artist_profile_in_tour"));
  }

  var hasNationality = nationality != null && nationality != "";
  var profileStatusItems = [{
    value: (0,helpers/* formatNumber */.uf)(totalFollower || 0),
    label: t("key_profile_status_followers"),
    type: config/* Constants.profileStatusType.PROFILE_STATUS_FOLLOWER */.gT.profileStatusType.PROFILE_STATUS_FOLLOWER
  }, {
    value: (0,helpers/* formatNumber */.uf)(totalFollowing || 0),
    label: t("key_profile_status_followings"),
    type: config/* Constants.profileStatusType.PROFILE_STATUS_FOLLOWING */.gT.profileStatusType.PROFILE_STATUS_FOLLOWING
  }, {
    value: (0,helpers/* formatNumber */.uf)(totalConnection || 0),
    label: t("key_profile_status_connections"),
    type: config/* Constants.profileStatusType.PROFILE_STATUS_CONNECTION */.gT.profileStatusType.PROFILE_STATUS_CONNECTION
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
    style: [ArtistInfoView_styles.container, props.style],
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
      style: isMobileVersion ? {} : {
        alignSelf: "center",
        maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
        width: "100%"
      },
      children: [isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: ArtistInfoView_styles.userInfoContainer,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ArtistInfoView_CAvatar, {
            url: avatar || "Local:defaultArtist",
            size: 70,
            alt: "".concat(displayName, " Avatar")
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: [ArtistInfoView_styles.nameContainer, isMobileVersion ? {
              alignItems: "flex-start",
              marginLeft: 16
            } : {}],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: {
                flexDirection: "row",
                marginTop: 4,
                paddingRight: 40
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: [ArtistInfoView_styles.displayName, isMobileVersion ? {
                  fontSize: 16,
                  lineHeight: 19.5
                } : {}],
                children: displayName
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
              style: [ArtistInfoView_styles.username, {
                marginTop: 4
              }, isMobileVersion ? {
                fontSize: 10,
                lineHeight: 18
              } : {}],
              children: ["@", username]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
              style: [ArtistInfoView_styles.rowContainer, {
                alignItems: "center",
                marginTop: 4
              }],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
                style: {
                  width: 18,
                  height: 18,
                  marginRight: 2
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                  source: config/* Images.iconSearchArtist */.rU.iconSearchArtist,
                  style: ArtistInfoView_styles.icon,
                  height: 18,
                  width: 18,
                  layout: "fixed",
                  resizeMode: "contain"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
                texts: artistTypeTexts,
                textStyle: {
                  color: config/* Colors.white */.wL.white,
                  lineHeight: 20,
                  fontSize: 12,
                  fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
                },
                dotStyle: {
                  backgroundColor: config/* Colors.white */.wL.white
                }
              })]
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
          style: ArtistInfoView_styles.bio,
          children: bio
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [ArtistInfoView_styles.rowContainer, {
            marginTop: 5,
            marginHorizontal: 16,
            justifyContent: "space-between"
          }],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: ArtistInfoView_styles.rowContainer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: {
                width: 14,
                height: 14,
                marginRight: 4
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconTagMusic */.rU.iconTagMusic,
                width: 14,
                height: 14
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [ArtistInfoView_styles.text, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: genreName
            }), moreGenre && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 22,
                borderRadius: 11,
                marginLeft: 4,
                borderColor: config/* Colors.spliterLine */.wL.spliterLine
              },
              onPress: function onPress() {
                alertModalGenreRef.current.alert("Music", fullGenreNames);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: [ArtistInfoView_styles.boldText, isMobileVersion ? {
                  fontSize: 10,
                  lineHeight: 12
                } : {}],
                children: moreGenre
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
            style: ArtistInfoView_styles.rowContainer,
            onPress: function onPress() {
              return nationality !== "" && nationality !== null ? alertModalLocationRef.current.alert("Location", nationality) : null;
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: {
                width: 14,
                height: 14,
                marginRight: 4
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconLocationPin */.rU.iconLocationPin,
                width: 12,
                height: 12
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [ArtistInfoView_styles.text, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
                style: {
                  fontStyle: "normal"
                },
                children: nationality
              })
            })]
          })]
        })]
      }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ArtistInfoView_CAvatar, {
          url: avatar || "Local:defaultArtist",
          size: 130,
          style: {
            alignSelf: "center",
            marginTop: -65
          },
          alt: "".concat(displayName, " Avatar")
        }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
          style: {
            alignSelf: "center"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: ArtistInfoView_styles.nameContainer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
              style: {
                flexDirection: "row",
                marginTop: 25,
                alignItems: "center"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: ArtistInfoView_styles.displayName,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
                  children: displayName
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((Text_default()), {
              style: [ArtistInfoView_styles.username, {
                marginTop: 13
              }],
              children: ["@", username]
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
              style: [ArtistInfoView_styles.rowContainer, {
                alignItems: "center",
                marginTop: 15
              }],
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                source: config/* Images.iconSearchArtist */.rU.iconSearchArtist,
                style: ArtistInfoView_styles.icon,
                height: 20,
                width: 20,
                layout: "fixed",
                resizeMode: "contain"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* DotSplitedText */.cf, {
                texts: artistTypeTexts,
                textStyle: {
                  color: config/* Colors.white */.wL.white,
                  lineHeight: 20,
                  fontSize: 16,
                  fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
                },
                dotStyle: {
                  backgroundColor: config/* Colors.white */.wL.white,
                  width: 3,
                  height: 3,
                  borderRadius: 3
                },
                style: {
                  marginLeft: 4
                }
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
          style: [ArtistInfoView_styles.rowContainer, {
            marginTop: 5,
            marginHorizontal: 16,
            justifyContent: "space-between",
            alignItems: "flex-end"
          }],
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
            style: ArtistInfoView_styles.rowContainer,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: config/* Images.iconTagMusic */.rU.iconTagMusic,
              style: [ArtistInfoView_styles.locationPin]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [ArtistInfoView_styles.text, {
                marginLeft: 8
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: genreName
            }), moreGenre && /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
              style: {
                alignItems: "center",
                justifyContent: "center",
                paddingHorizontal: 8,
                borderWidth: 1,
                height: 25,
                borderRadius: 25,
                marginLeft: 8,
                borderColor: config/* Colors.spliterLine */.wL.spliterLine
              },
              onPress: function onPress() {
                alertModalGenreRef.current.alert("Music", fullGenreNames);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                style: ArtistInfoView_styles.boldText,
                children: moreGenre
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
            style: ArtistInfoView_styles.bio,
            children: bio
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
            style: [ArtistInfoView_styles.rowContainer],
            disabled: !hasNationality,
            onPress: function onPress() {
              if (hasNationality) alertModalLocationRef.current.alert("Location", nationality);
            },
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              width: 20,
              height: 20,
              layout: "fixed",
              source: config/* Images.iconLocationPin */.rU.iconLocationPin,
              style: ArtistInfoView_styles.locationPin
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [ArtistInfoView_styles.text, {
                marginLeft: 5
              }, isMobileVersion ? {
                fontSize: 12,
                lineHeight: 20
              } : {}],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("address", {
                style: {
                  fontStyle: "normal"
                },
                children: nationality
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* AlertModal */.VF, {
        icon: config/* Images.iconTagMusic */.rU.iconTagMusic,
        ref: alertModalGenreRef,
        isMobileVersion: isMobileVersion,
        isSmall: true
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(molecules/* AlertModal */.VF, {
        icon: config/* Images.iconLocationPin */.rU.iconLocationPin,
        ref: alertModalLocationRef,
        isMobileVersion: isMobileVersion,
        isSmall: true
      })]
    })
  });
};

var ArtistInfoView_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch",
    backgroundColor: config/* Colors.black */.wL.black,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25
  },
  userInfoContainer: {
    alignSelf: "stretch",
    flexDirection: "row",
    marginHorizontal: 16,
    marginTop: 15
  },
  displayName: {
    fontSize: 28,
    lineHeight: 32,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: "white"
  },
  durationContainer: {
    marginTop: 16,
    marginHorizontal: 16,
    marginBottom: 15
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  locationPin: {
    width: 12,
    height: 12,
    marginRight: 4
  },
  text: {
    color: "white",
    fontSize: 16,
    lineHeight: 20,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  },
  boldText: {
    color: "white",
    fontSize: 14,
    lineHeight: 17,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  locationText: {},
  tagContainer: {
    height: 20,
    paddingHorizontal: 6,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground
  },
  tagText: {
    fontSize: 16,
    lineHeight: 18,
    color: config/* Colors.whiteText */.wL.whiteText
  },
  eventButtonContainer: {
    borderRadius: 12,
    height: 24,
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    alignItems: "center",
    justifyContent: "center",
    width: 104,
    flexDirection: "row"
  },
  eventButtonText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    color: "white"
  },
  eventIcon: {
    width: 11,
    height: 11,
    marginRight: 4
  },
  badgeIcon: {
    marginLeft: 8,
    width: 10,
    height: 10
  },
  nameContainer: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
  },
  username: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 18,
    color: config/* Colors.placeholder */.wL.placeholder
  },
  icon: {
    width: 19,
    height: 19
  },
  bio: {
    marginLeft: 16,
    marginTop: 8,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    color: config/* Colors.white */.wL.white,
    maxWidth: 340,
    textAlign: "center"
  }
});
/* harmony default export */ var components_ArtistInfoView = (ArtistInfoView);
// EXTERNAL MODULE: ./node_modules/react-blur/dist/blur.js
var dist_blur = __webpack_require__(54);
;// CONCATENATED MODULE: ./src/modules/profile/artist/components/MobileArtistInfoView.js













var MobileArtistInfoView_ArtistInfoView = function ArtistInfoView(props) {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var alertModalGenreRef = useRef(null);
  var alertModalLocationRef = useRef(null);
  if (!props.item) return null;
  var _props$item = props.item,
      id = _props$item.id,
      isFollow = _props$item.isFollow,
      profileId = _props$item.profileId,
      isVirtual = _props$item.isVirtual,
      isInPerson = _props$item.isInPerson,
      title = _props$item.title,
      location = _props$item.location,
      startDate = _props$item.startDate,
      periodString = _props$item.periodString,
      totalFollower = _props$item.totalFollower,
      totalFollowing = _props$item.totalFollowing,
      totalConnection = _props$item.totalConnection,
      avatar = _props$item.avatar,
      displayName = _props$item.displayName,
      username = _props$item.username,
      rating = _props$item.rating,
      userType = _props$item.userType,
      activity = _props$item.activity,
      bio = _props$item.bio,
      nationality = _props$item.nationality,
      genres = _props$item.genres;
  var genreItems = [];

  if (genres) {
    genreItems = genres;
  }

  var userTypeName = "Artist";
  var genreName = genreItems.length > 0 ? genreItems[0].title : null;
  var moreGenre = genreItems.length > 1 ? "+" + (genreItems.length - 1) : null;
  var fullGenreNames = genreItems.map(function (genreItem) {
    return genreItem.title;
  }).join(", ");
  var artistTypeTexts = [userTypeName];
  var isInTour = activity == Constants.artistActivity.ACTIVITY_IN_TOUR;

  if (isInTour) {
    artistTypeTexts.push(t("key_artist_profile_in_tour"));
  }

  var hasNationality = nationality != null && nationality != "";
  var profileStatusItems = [{
    value: formatNumber(totalFollower || 0),
    label: t("key_profile_status_followers"),
    type: Constants.profileStatusType.PROFILE_STATUS_FOLLOWER
  }, {
    value: formatNumber(totalFollowing || 0),
    label: t("key_profile_status_followings"),
    type: Constants.profileStatusType.PROFILE_STATUS_FOLLOWING
  }, {
    value: formatNumber(totalConnection || 0),
    label: t("key_profile_status_connections"),
    type: Constants.profileStatusType.PROFILE_STATUS_CONNECTION
  }];
  return /*#__PURE__*/_jsx(View, {
    style: [MobileArtistInfoView_styles.container, props.style],
    children: /*#__PURE__*/_jsxs(View, {
      style: {
        alignSelf: "center",
        maxWidth: Constants.PROFILE_PAGE_WIDTH,
        width: "100%"
      },
      children: [/*#__PURE__*/_jsx(CAvatar, {
        url: avatar,
        size: 130,
        style: {
          alignSelf: "center",
          marginTop: -65
        }
      }), /*#__PURE__*/_jsx(View, {
        style: {
          alignSelf: "center"
        },
        children: /*#__PURE__*/_jsxs(View, {
          style: MobileArtistInfoView_styles.nameContainer,
          children: [/*#__PURE__*/_jsxs(View, {
            style: {
              flexDirection: "row",
              marginTop: 25,
              alignItems: "center"
            },
            children: [/*#__PURE__*/_jsx(Text, {
              style: MobileArtistInfoView_styles.displayName,
              children: /*#__PURE__*/_jsx("h1", {
                children: displayName
              })
            }), /*#__PURE__*/_jsx(BarRatingView, {
              rating: rating,
              style: {
                width: 20,
                height: 20,
                position: "absoute",
                right: -12,
                top: 0
              },
              maxHeight: 20,
              barStyle: {
                marginLeft: 1.07,
                width: 3.21,
                borderRadius: 3.1
              }
            })]
          }), /*#__PURE__*/_jsxs(Text, {
            style: [MobileArtistInfoView_styles.username, {
              marginTop: 13
            }],
            children: ["@", username]
          }), /*#__PURE__*/_jsxs(View, {
            style: [MobileArtistInfoView_styles.rowContainer, {
              alignItems: "center",
              marginTop: 15
            }],
            children: [/*#__PURE__*/_jsx(CImage, {
              source: Images.iconSearchArtist,
              style: MobileArtistInfoView_styles.icon,
              height: 25,
              width: 25,
              layout: "fixed",
              resizeMode: "contain"
            }), /*#__PURE__*/_jsx(DotSplitedText, {
              texts: artistTypeTexts,
              textStyle: {
                color: Colors.white,
                lineHeight: 20,
                fontSize: 16,
                fontFamily: Fonts.primaryRegular
              },
              dotStyle: {
                backgroundColor: Colors.white,
                width: 3,
                height: 3,
                borderRadius: 3
              },
              style: {
                marginLeft: 4
              }
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs(View, {
        style: [MobileArtistInfoView_styles.rowContainer, {
          marginTop: 5,
          marginHorizontal: 16,
          justifyContent: "space-between",
          alignItems: "flex-end"
        }],
        children: [/*#__PURE__*/_jsxs(View, {
          style: MobileArtistInfoView_styles.rowContainer,
          children: [/*#__PURE__*/_jsx(CImage, {
            width: 16,
            height: 16,
            layout: "fixed",
            source: Images.iconTagMusic,
            style: [MobileArtistInfoView_styles.locationPin]
          }), /*#__PURE__*/_jsx(Text, {
            style: [MobileArtistInfoView_styles.text, {
              marginLeft: 8
            }],
            children: genreName
          }), moreGenre && /*#__PURE__*/_jsx(TouchableOpacity, {
            style: {
              alignItems: "center",
              justifyContent: "center",
              paddingHorizontal: 8,
              borderWidth: 1,
              height: 25,
              borderRadius: 25,
              marginLeft: 8,
              borderColor: Colors.spliterLine
            },
            onPress: function onPress() {
              alertModalGenreRef.current.alert("Music", fullGenreNames);
            },
            children: /*#__PURE__*/_jsx(Text, {
              style: MobileArtistInfoView_styles.boldText,
              children: moreGenre
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          style: MobileArtistInfoView_styles.bio,
          children: bio
        }), /*#__PURE__*/_jsxs(TouchableOpacity, {
          style: [MobileArtistInfoView_styles.rowContainer],
          disabled: !hasNationality,
          onPress: function onPress() {
            if (hasNationality) alertModalLocationRef.current.alert("Location", nationality);
          },
          children: [/*#__PURE__*/_jsx(CImage, {
            width: 20,
            height: 20,
            layout: "fixed",
            source: Images.iconLocationPin,
            style: MobileArtistInfoView_styles.locationPin
          }), /*#__PURE__*/_jsx(Text, {
            style: [MobileArtistInfoView_styles.text, {
              marginLeft: 5
            }],
            children: nationality
          })]
        })]
      }), /*#__PURE__*/_jsx(AlertModal, {
        icon: Images.iconTagMusic,
        ref: alertModalGenreRef
      }), /*#__PURE__*/_jsx(AlertModal, {
        icon: Images.iconLocationPin,
        ref: alertModalLocationRef
      })]
    })
  });
};

var MobileArtistInfoView_styles = StyleSheet_default().create({
  container: {
    alignSelf: "stretch",
    backgroundColor: config/* Colors.black */.wL.black,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25
  },
  userInfoContainer: {
    alignSelf: "stretch",
    flexDirection: "row",
    marginHorizontal: 16,
    marginTop: 15
  },
  displayName: {
    fontSize: 28,
    lineHeight: 32,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    color: "white"
  },
  durationContainer: {
    marginTop: 16,
    marginHorizontal: 16,
    marginBottom: 15
  },
  rowContainer: {
    flexDirection: "row",
    alignItems: "center"
  },
  locationPin: {
    width: 12,
    height: 12,
    marginRight: 4
  },
  text: {
    color: "white",
    fontSize: 16,
    lineHeight: 20,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular
  },
  boldText: {
    color: "white",
    fontSize: 14,
    lineHeight: 17,
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold
  },
  locationText: {},
  tagContainer: {
    height: 20,
    paddingHorizontal: 6,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground
  },
  tagText: {
    fontSize: 16,
    lineHeight: 18,
    color: config/* Colors.whiteText */.wL.whiteText
  },
  eventButtonContainer: {
    borderRadius: 12,
    height: 24,
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    alignItems: "center",
    justifyContent: "center",
    width: 104,
    flexDirection: "row"
  },
  eventButtonText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 18,
    color: "white"
  },
  eventIcon: {
    width: 11,
    height: 11,
    marginRight: 4
  },
  badgeIcon: {
    marginLeft: 8,
    width: 10,
    height: 10
  },
  nameContainer: {
    flex: 1,
    flexDirection: "column",
    alignItems: "center"
  },
  username: {
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 18,
    color: config/* Colors.placeholder */.wL.placeholder
  },
  icon: {
    width: 19,
    height: 19
  },
  bio: {
    marginLeft: 16,
    marginTop: 8,
    fontFamily: config/* Fonts.primaryRegular */.F3.primaryRegular,
    fontSize: 16,
    lineHeight: 20,
    color: config/* Colors.white */.wL.white,
    maxWidth: 340,
    textAlign: "center"
  }
});
/* harmony default export */ var MobileArtistInfoView = ((/* unused pure expression or super */ null && (MobileArtistInfoView_ArtistInfoView)));
;// CONCATENATED MODULE: ./src/modules/profile/artist/views/ArtistProfileView.js
























var ArtistProfileView = function ArtistProfileView(props) {
  var _props$artist, _photos, _props$artist2, _props$artist3, _props$artist4, _props$artist5, _props$artist6, _props$artist7, _props$artist8, _props$artist9, _props$artist10, _props$artist11, _props$artist12, _props$artist13, _props$artist13$photo, _props$artist14, _JSON$parse$, _props$artist15, _props$artist16, _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _props$artist17, _props$artist18, _props$artist19, _props$artist19$photo, _props$artist20, _props$artist23;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var navigation = (0,router.useRouter)();
  var modalRef = (0,react.useRef)(null);
  var contactModalRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(false),
      isShowMenu = _useState[0],
      setIsShowMenu = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isReady = _useState2[0],
      setIsReady = _useState2[1];

  var tabType = props.tabType,
      subTabType = props.subTabType,
      isMobileVersion = props.isMobileVersion;

  var _useState3 = (0,react.useState)(0),
      activeIndex = _useState3[0],
      setActiveIndex = _useState3[1];

  var PROFILE_COVER_HEADER_HEIGHT = isMobileVersion ? 239 : 573;
  var PROFILE_COVER_IMAGE_HEIGHT = isMobileVersion ? 239 : 450;
  var PROFILE_PANEL_BORDER_RADIUS = isMobileVersion ? 25 : 123;
  var items = isMobileVersion ? [{
    id: 3,
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    type: config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE
  }, {
    id: 13,
    title: t("key_modal_title_share"),
    icon: config/* Images.iconShareColored */.rU.iconShareColored,
    type: config/* Constants.profileMenuType.PROFILE_MENU_SHARE */.gT.profileMenuType.PROFILE_MENU_SHARE
  }
  /*{
  id: 6,
  title: t("key_report"),
  icon: Images.iconReport,
  type: Constants.profileMenuType.PROFILE_MENU_REPORT,
  },*/
  ] : [{
    id: 3,
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    type: config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE
  }
  /*{
  id: 6,
  title: t("key_report"),
  icon: Images.iconReport,
  type: Constants.profileMenuType.PROFILE_MENU_REPORT,
  },*/
  ];

  var onPressMenuItem = function onPressMenuItem(item) {
    if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ID_PROFILE */.gT.profileModalType.PROFILE_MODAL_ID_PROFILE);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_REPORT */.gT.profileMenuType.PROFILE_MENU_REPORT) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_REPORT */.gT.profileModalType.PROFILE_MODAL_REPORT, {
        reportCategory: config/* Constants.reportCategory.REPORT_ARTIST */.gT.reportCategory.REPORT_ARTIST
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_SHARE */.gT.profileMenuType.PROFILE_MENU_SHARE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE);
    }
  };

  var coverPic = "Local:imagePlaceholder";

  if (props.artist.coverPic) {
    coverPic = props.artist.coverPic;
  } else if (props.artist.avatar) {
    coverPic = props.artist.avatar;
  }

  var onChangeIsShown = function onChangeIsShown(flag) {
    setIsShowMenu(flag);
  };

  var photos = props === null || props === void 0 ? void 0 : (_props$artist = props.artist) === null || _props$artist === void 0 ? void 0 : _props$artist.photos;

  if (photos && !Array.isArray(photos)) {
    photos = JSON.parse(photos);
  }

  var backgroundImage = ((_photos = photos) === null || _photos === void 0 ? void 0 : _photos.length) > 0 ? photos[0].url : "Local:imagePlaceholder";
  var canonicalURL = "https://".concat("www.cocktayl.co").concat((0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$artist2 = props.artist) === null || _props$artist2 === void 0 ? void 0 : _props$artist2.id, props === null || props === void 0 ? void 0 : (_props$artist3 = props.artist) === null || _props$artist3 === void 0 ? void 0 : _props$artist3.displayName, null, config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST, tabType === "about" ? "about" : "about#".concat(tabType)));
  (0,react.useEffect)(function () {
    setIsReady(true);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: ArtistProfileView_styles.container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": canonicalURL,
            url: canonicalURL,
            name: props === null || props === void 0 ? void 0 : (_props$artist4 = props.artist) === null || _props$artist4 === void 0 ? void 0 : _props$artist4.displayName,
            datePublished: props === null || props === void 0 ? void 0 : (_props$artist5 = props.artist) === null || _props$artist5 === void 0 ? void 0 : _props$artist5.createdAt,
            dateModified: props === null || props === void 0 ? void 0 : (_props$artist6 = props.artist) === null || _props$artist6 === void 0 ? void 0 : _props$artist6.updatedAt,
            image: [props === null || props === void 0 ? void 0 : (_props$artist7 = props.artist) === null || _props$artist7 === void 0 ? void 0 : _props$artist7.avatar].filter(function (i) {
              return i !== null;
            }).map(function (i) {
              return {
                "@id": i
              };
            })
          })
        }
      }, "structured-data")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      noindex: false,
      nofollow: false,
      title: "".concat(props === null || props === void 0 ? void 0 : (_props$artist8 = props.artist) === null || _props$artist8 === void 0 ? void 0 : _props$artist8.displayName).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
      description: "Discover ".concat(props === null || props === void 0 ? void 0 : (_props$artist9 = props.artist) === null || _props$artist9 === void 0 ? void 0 : _props$artist9.displayName, " ").concat(tabType === "media" ? "media gallery on ".concat("Cocktayl", ".") : tabType === "wall" ? "community on ".concat("Cocktayl", " - posts about info, news and much more.") : tabType === "memories" ? "reviews on ".concat("Cocktayl", ".") : tabType === "festivals" ? "festivals on ".concat("Cocktayl", " - dates, location and much more.") : "profile on ".concat("Cocktayl", " - events, tickets and much more.") //else about
      ),
      canonical: canonicalURL,
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: canonicalURL,
        title: "".concat(props === null || props === void 0 ? void 0 : (_props$artist10 = props.artist) === null || _props$artist10 === void 0 ? void 0 : _props$artist10.displayName).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
        description: "Discover ".concat(props === null || props === void 0 ? void 0 : (_props$artist11 = props.artist) === null || _props$artist11 === void 0 ? void 0 : _props$artist11.displayName, " ").concat(tabType === "media" ? "media gallery on ".concat("Cocktayl", ".") : tabType === "wall" ? "community on ".concat("Cocktayl", " - posts about info, news and much more.") : tabType === "memories" ? "reviews on ".concat("Cocktayl", ".") : tabType === "festivals" ? "festivals on ".concat("Cocktayl", " - dates, location and much more.") : "profile on ".concat("Cocktayl", " - events, tickets and much more.") //else about
        ),
        images: [{
          url: props !== null && props !== void 0 && (_props$artist12 = props.artist) !== null && _props$artist12 !== void 0 && _props$artist12.photos && (props === null || props === void 0 ? void 0 : (_props$artist13 = props.artist) === null || _props$artist13 === void 0 ? void 0 : (_props$artist13$photo = _props$artist13.photos) === null || _props$artist13$photo === void 0 ? void 0 : _props$artist13$photo.length) > 0 ? props !== null && props !== void 0 && (_props$artist14 = props.artist) !== null && _props$artist14 !== void 0 && _props$artist14.photos ? (_JSON$parse$ = JSON.parse(props === null || props === void 0 ? void 0 : (_props$artist15 = props.artist) === null || _props$artist15 === void 0 ? void 0 : _props$artist15.photos)[0]) === null || _JSON$parse$ === void 0 ? void 0 : _JSON$parse$.url : "" : (props === null || props === void 0 ? void 0 : (_props$artist16 = props.artist) === null || _props$artist16 === void 0 ? void 0 : _props$artist16.avatar) || "https://".concat("www.cocktayl.co", "/images/").concat( true ? ((_process$env$NEXT_PUB = "Cocktayl") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "image_placeholder_new.png"),
          width: 1200,
          height: 630,
          alt: "".concat(props === null || props === void 0 ? void 0 : (_props$artist17 = props.artist) === null || _props$artist17 === void 0 ? void 0 : _props$artist17.displayName).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
      style: [ArtistProfileView_styles.container],
      contentContainerStyle: ArtistProfileView_styles.scrollView,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
        style: {
          alignSelf: "stretch",
          height: PROFILE_COVER_HEADER_HEIGHT
        },
        children: [isReady && /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
          objectFit: "fill",
          imgUrl: backgroundImage
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "bg-white/2 absolute bottom-0 left-0 right-0 top-0",
          style: {
            backdropFilter: "blur(40px)"
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileHeader["default"], {
          photos: props !== null && props !== void 0 && (_props$artist18 = props.artist) !== null && _props$artist18 !== void 0 && _props$artist18.photos && (props === null || props === void 0 ? void 0 : (_props$artist19 = props.artist) === null || _props$artist19 === void 0 ? void 0 : (_props$artist19$photo = _props$artist19.photos) === null || _props$artist19$photo === void 0 ? void 0 : _props$artist19$photo.length) > 0 ? (props === null || props === void 0 ? void 0 : (_props$artist20 = props.artist) === null || _props$artist20 === void 0 ? void 0 : _props$artist20.photos) || [] : [{
            url: "Local:imagePlaceholder"
          }],
          activeIndex: activeIndex,
          setActiveIndex: setActiveIndex,
          items: items,
          artist: props.artist,
          onPressMenuItem: onPressMenuItem,
          isShowMenu: isShowMenu,
          onChangeIsShown: onChangeIsShown,
          style: {
            maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
            width: "100%",
            height: PROFILE_COVER_IMAGE_HEIGHT,
            marginBottom: isMobileVersion ? 0 : PROFILE_PANEL_BORDER_RADIUS,
            alignSelf: "center"
          },
          isMobileVersion: isMobileVersion,
          category: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST
        })]
      }), isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)(components_ArtistInfoView, {
        style: {
          marginTop: -1 * PROFILE_PANEL_BORDER_RADIUS,
          borderTopLeftRadius: PROFILE_PANEL_BORDER_RADIUS,
          borderTopRightRadius: PROFILE_PANEL_BORDER_RADIUS
        },
        item: props.artist,
        loadData: props.loadData,
        openContact: function openContact() {
          return contactModalRef.current.showModal();
        },
        isMobileVersion: isMobileVersion
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(components_ArtistInfoView, {
        style: {
          marginTop: -1 * PROFILE_PANEL_BORDER_RADIUS,
          borderTopLeftRadius: PROFILE_PANEL_BORDER_RADIUS,
          borderTopRightRadius: PROFILE_PANEL_BORDER_RADIUS
        },
        item: props.artist,
        loadData: props.loadData,
        openContact: function openContact() {
          return contactModalRef.current.showModal();
        },
        isMobileVersion: isMobileVersion
      }), isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileBottomView["default"], {
        style: {
          // marginTop: -25,
          maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
          width: "100%",
          alignSelf: "center"
        },
        item: props.artist,
        category: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST,
        isNested: true,
        initialTabType: tabType,
        subTabType: subTabType,
        isMobileVersion: isMobileVersion
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ProfileBottomView["default"], {
        style: {
          alignSelf: "center",
          maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
          width: "100%"
        },
        item: props.artist,
        category: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST,
        isNested: true,
        initialTabType: tabType,
        subTabType: subTabType,
        isMobileVersion: isMobileVersion
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ProfileModalContainer, {
        ref: modalRef,
        item: props.artist,
        category: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST,
        isMobileVersion: isMobileVersion
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ProfileBottomMenuBar, {
      profile: props.artist,
      isMobileVersion: isMobileVersion,
      category: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST,
      hideContact: true,
      hideShare: isMobileVersion,
      onMorePress: function onMorePress() {
        setIsShowMenu(true);
      },
      onContactPress: function onContactPress() {
        return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
      },
      onSharePress: function onSharePress() {
        return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE);
      },
      renderButton: function renderButton() {
        var _props$artist21, _props$artist22;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
          buttonTitle: t("key_button_calendar"),
          url: "".concat((0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$artist21 = props.artist) === null || _props$artist21 === void 0 ? void 0 : _props$artist21.id, props === null || props === void 0 ? void 0 : (_props$artist22 = props.artist) === null || _props$artist22 === void 0 ? void 0 : _props$artist22.displayName, null, config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST, "calendar")),
          filled: true,
          fontSize: isMobileVersion ? 12 : 16,
          iconStyle: {
            width: 18,
            height: 18
          },
          icon: config/* Images.iconCalendarColored */.rU.iconCalendarColored,
          style: isMobileVersion ? {
            height: 32,
            width: "100%"
          } : {
            height: 40,
            width: 320
          },
          isMobileVersion: isMobileVersion,
          isHeading: true
        });
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ContactModal, {
      ref: contactModalRef,
      item: props.artist,
      contact: (_props$artist23 = props.artist) === null || _props$artist23 === void 0 ? void 0 : _props$artist23.contact,
      category: config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST,
      isMobileVersion: isMobileVersion
    })]
  });
};

var ArtistProfileView_styles = StyleSheet_default().create({
  container: {
    flex: 1,
    backgroundColor: config/* Colors.black */.wL.black,
    marginBottom: 0
  },
  headerStyle: {
    height: 290,
    width: "100%"
  },
  bottomContainer: {
    height: 90,
    alignSelf: "stretch",
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    marginBottom: 50,
    paddingHorizontal: 30,
    justifyContent: "center"
  },
  scrollView: {
    flexGrow: 1,
    flexDirection: "column"
  },
  moreButton: {
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    borderRadius: 20,
    padding: 5
  }
});
/* harmony default export */ var views_ArtistProfileView = (ArtistProfileView);
;// CONCATENATED MODULE: ./src/modules/profile/artist/containers/ArtistProfileViewContainer.js





var ArtistProfileViewContainer = function ArtistProfileViewContainer(props) {
  var artistEvents = props.artistEvents,
      isMobileVersion = props.isMobileVersion;
  var id = props.id,
      profileId = props.profileId,
      tabType = props.tabType,
      subTabType = props.subTabType,
      item = props.item;

  var _useState = (0,react.useState)(item),
      detail = _useState[0],
      setDetail = _useState[1];

  var loadData = function loadData() {
    if (id) {
      DAO/* ArtistDao.findOne */.uf.findOne(id).then(function (result) {
        setDetail(result);
      });
    } else if (profileId) {
      DAO/* ArtistDao.findOneByProfileId */.uf.findOneByProfileId(profileId).then(function (result) {
        setDetail(result);
      });
    }
  }; // useEffect(() => {
  //     loadData();
  // }, [props.category, props.id, props.profileId]);


  return detail ? /*#__PURE__*/(0,jsx_runtime.jsx)(views_ArtistProfileView, {
    artist: detail,
    loadData: loadData,
    tabType: tabType,
    subTabType: subTabType,
    artistEvents: artistEvents,
    isMobileVersion: isMobileVersion
  }) : null;
};

/* harmony default export */ var containers_ArtistProfileViewContainer = (ArtistProfileViewContainer);
;// CONCATENATED MODULE: ./src/modules/profile/venue/views/VenueProfileView.js


var VenueProfileView_objectSpread2;

function VenueProfileView_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function VenueProfileView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? VenueProfileView_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : VenueProfileView_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var PopupMenuListModal = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 94843));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94843)];
    }
  }
});
var VenueInfoView = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 7224).then(__webpack_require__.bind(__webpack_require__, 27224));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(27224)];
    }
  }
});
var VenueProfileView_ProfileHeader = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 62219));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(62219)];
    }
  }
});
var VenueProfileView_ProfileBottomView = dynamic_default()(function () {
  return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 84972));
}, {
  ssr: true,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(84972)];
    }
  }
});

var VenueProfileView = function VenueProfileView(props) {
  var _props$venue4, _props$venue4$covers, _photos, _props$venue5, _props$venue6, _props$venue7, _props$venue8, _props$venue9, _props$venue10, _props$venue11, _props$venue12, _props$venue13, _props$venue14, _props$venue14$descri, _props$venue15, _props$venue16, _props$venue17, _props$venue18, _process$env$NEXT_PUB, _process$env$NEXT_PUB2, _props$venue19, _props$venue20, _props$venue21, _props$venue22, _props$venue22$covers, _props$venue23, _props$venue23$covers;

  var _useTranslation = (0,es_useTranslation/* useTranslation */.$)(),
      t = _useTranslation.t;

  var modalRef = (0,react.useRef)(null);
  var navigation = (0,router.useRouter)();

  var _useState = (0,react.useState)(false),
      isShowMenu = _useState[0],
      setIsShowMenu = _useState[1];

  var tabType = props.tabType,
      subTabType = props.subTabType,
      venueEvents = props.venueEvents,
      category = props.category,
      isMobileVersion = props.isMobileVersion;

  var _useState2 = (0,react.useState)(0),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isShowMenuMagic = _useState3[0],
      setIsShowMenuMagic = _useState3[1];

  var itemsOther = isMobileVersion ? [{
    id: 12,
    title: t("key_report_mistake"),
    icon: config/* Images.iconEdit */.rU.iconEdit,
    type: config/* Constants.profileMenuType.PROFILE_MENU_REPORT_MISTAKE */.gT.profileMenuType.PROFILE_MENU_REPORT_MISTAKE
  }, {
    id: 3,
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    type: config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE
  }, {
    id: 13,
    title: t("key_modal_title_share"),
    icon: config/* Images.iconShareColored */.rU.iconShareColored,
    type: config/* Constants.profileMenuType.PROFILE_MENU_SHARE */.gT.profileMenuType.PROFILE_MENU_SHARE
  }] : [{
    id: 12,
    title: t("key_report_mistake"),
    icon: config/* Images.iconEdit */.rU.iconEdit,
    type: config/* Constants.profileMenuType.PROFILE_MENU_REPORT_MISTAKE */.gT.profileMenuType.PROFILE_MENU_REPORT_MISTAKE
  }, {
    id: 3,
    title: t("key_id_profile"),
    icon: config/* Images.iconBarcode */.rU.iconBarcode,
    type: config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE
  }];
  var itemsMagic = [{
    id: 11,
    title: t("key_booking"),
    icon: config/* Images.iconBooking */.rU.iconBooking,
    type: config/* Constants.profileMenuType.PROFILE_MENU_BOOKING */.gT.profileMenuType.PROFILE_MENU_BOOKING
  } // {
  //   id: 7,
  //   title: t("key_insights"),
  //   icon: Images.iconInsight,
  //   type: Constants.profileMenuType.PROFILE_MENU_INSIGHTS,
  // },
  ];

  var onPressMenuItem = function onPressMenuItem(item) {
    if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_EDITION */.gT.profileMenuType.PROFILE_MENU_EDITION) {
      var _props$venue, _props$venue2, _props$venue3;

      navigation.push("".concat((0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$venue = props.venue) === null || _props$venue === void 0 ? void 0 : _props$venue.id, props === null || props === void 0 ? void 0 : (_props$venue2 = props.venue) === null || _props$venue2 === void 0 ? void 0 : _props$venue2.title, props === null || props === void 0 ? void 0 : (_props$venue3 = props.venue) === null || _props$venue3 === void 0 ? void 0 : _props$venue3.startDate, category, "edition")));
    }

    if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_ID_PROFILE */.gT.profileMenuType.PROFILE_MENU_ID_PROFILE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ID_PROFILE */.gT.profileModalType.PROFILE_MODAL_ID_PROFILE);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_REPORT */.gT.profileMenuType.PROFILE_MENU_REPORT) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_REPORT */.gT.profileModalType.PROFILE_MODAL_REPORT, {
        reportCategory: config/* Constants.reportCategory.REPORT_FESTIVAL */.gT.reportCategory.REPORT_FESTIVAL
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_UPDATE */.gT.profileMenuType.PROFILE_MENU_UPDATE) {
      navigation.navigate("VenueUpdateScreen", {
        venueId: props.venue.id
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_CONTACT_HOST */.gT.profileMenuType.PROFILE_MENU_CONTACT_HOST) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_CALENDAR */.gT.profileMenuType.PROFILE_MENU_CALENDAR) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CALENDAR */.gT.profileModalType.PROFILE_MODAL_CALENDAR);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_TICKET_LINK */.gT.profileMenuType.PROFILE_MENU_TICKET_LINK) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ADD_TICKET_LINK */.gT.profileModalType.PROFILE_MODAL_ADD_TICKET_LINK);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_CALENDAR */.gT.profileMenuType.PROFILE_MENU_CALENDAR) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_ADD_TO_CALENDAR */.gT.profileModalType.PROFILE_MODAL_ADD_TO_CALENDAR);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_INSIGHTS */.gT.profileMenuType.PROFILE_MENU_INSIGHTS) {
      navigation.push({
        pathname: "/profile/insight",
        query: {
          id: props.venue.id,
          profileId: props.venue.profileId
        }
      });
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_REPORT_MISTAKE */.gT.profileMenuType.PROFILE_MENU_REPORT_MISTAKE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_REPORT_MISTAKE */.gT.profileModalType.PROFILE_MODAL_REPORT_MISTAKE);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_SHARE */.gT.profileMenuType.PROFILE_MENU_SHARE) {
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE);
    } else if (item.type == config/* Constants.profileMenuType.PROFILE_MENU_BOOKING */.gT.profileMenuType.PROFILE_MENU_BOOKING) {
      setIsShowMenuMagic(false);
      modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_BOOKING */.gT.profileModalType.PROFILE_MODAL_BOOKING);
    }
  };

  var onChangeIsShown = function onChangeIsShown(flag) {
    setIsShowMenu(flag);
  };

  var photos = props === null || props === void 0 ? void 0 : (_props$venue4 = props.venue) === null || _props$venue4 === void 0 ? void 0 : (_props$venue4$covers = _props$venue4.covers) === null || _props$venue4$covers === void 0 ? void 0 : _props$venue4$covers.map(function (i) {
    return {
      url: i.image
    };
  });

  if (photos && !Array.isArray(photos)) {
    photos = JSON.parse(photos);
  }

  var backgroundImage = ((_photos = photos) === null || _photos === void 0 ? void 0 : _photos.length) > 0 ? photos[activeIndex].url : "Local:imagePlaceholder";
  var item = props === null || props === void 0 ? void 0 : props.venue;
  var id = item === null || item === void 0 ? void 0 : item.id;
  var nickname = item === null || item === void 0 ? void 0 : item.nickname;
  var slug = (0,helpers_0/* getSlugFromName */.g_)(nickname, null);
  var canonicalURL = "https://".concat("www.cocktayl.co").concat((0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$venue5 = props.venue) === null || _props$venue5 === void 0 ? void 0 : _props$venue5.id, props === null || props === void 0 ? void 0 : (_props$venue6 = props.venue) === null || _props$venue6 === void 0 ? void 0 : _props$venue6.nickname, null, category, "about"));
  var metaTitle = "".concat(props === null || props === void 0 ? void 0 : (_props$venue7 = props.venue) === null || _props$venue7 === void 0 ? void 0 : _props$venue7.nickname).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl");
  var metaDescription = "Discover".concat(category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? " the" : "", " ").concat(props === null || props === void 0 ? void 0 : (_props$venue8 = props.venue) === null || _props$venue8 === void 0 ? void 0 : _props$venue8.nickname, " ").concat(tabType === "media" ? "media gallery on ".concat("Cocktayl", ".") : tabType === "wall" ? "community on ".concat("Cocktayl", " - posts about info, news and much more.") : tabType === "memories" ? "reviews on ".concat("Cocktayl", ".") : "profile on ".concat("Cocktayl", " - ").concat( false ? 0 : category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? "price, features" : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? "homes, features" : category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? "habitat, features" : "location, features", " and much more.") //else about
  );
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((0,formatHelpers/* getClass */.ll)("background", true), " mb-0 flex-1 flex flex-col"),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((head_default()), {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "@id": canonicalURL,
            url: canonicalURL,
            name: props === null || props === void 0 ? void 0 : (_props$venue9 = props.venue) === null || _props$venue9 === void 0 ? void 0 : _props$venue9.nickname,
            datePublished: props === null || props === void 0 ? void 0 : (_props$venue10 = props.venue) === null || _props$venue10 === void 0 ? void 0 : _props$venue10.createdAt,
            dateModified: props === null || props === void 0 ? void 0 : (_props$venue11 = props.venue) === null || _props$venue11 === void 0 ? void 0 : _props$venue11.updatedAt,
            image: [(props === null || props === void 0 ? void 0 : (_props$venue12 = props.venue) === null || _props$venue12 === void 0 ? void 0 : _props$venue12.logo) || (props === null || props === void 0 ? void 0 : (_props$venue13 = props.venue) === null || _props$venue13 === void 0 ? void 0 : _props$venue13.avatar)].filter(function (i) {
              return i !== null;
            }).map(function (i) {
              return {
                "@id": i
              };
            }),
            description: props === null || props === void 0 ? void 0 : (_props$venue14 = props.venue) === null || _props$venue14 === void 0 ? void 0 : (_props$venue14$descri = _props$venue14.description) === null || _props$venue14$descri === void 0 ? void 0 : _props$venue14$descri.replace(/(<([^>]+)>)/gi, "")
          })
        }
      }, "structured-data")
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
      title: metaTitle,
      description: metaDescription,
      canonical: canonicalURL,
      openGraph: {
        type: "website",
        locale: "en_EN",
        url: canonicalURL,
        title: metaTitle,
        description: metaDescription,
        images: [{
          url: props !== null && props !== void 0 && (_props$venue15 = props.venue) !== null && _props$venue15 !== void 0 && _props$venue15.logo ? props === null || props === void 0 ? void 0 : (_props$venue16 = props.venue) === null || _props$venue16 === void 0 ? void 0 : _props$venue16.logo : props !== null && props !== void 0 && (_props$venue17 = props.venue) !== null && _props$venue17 !== void 0 && _props$venue17.avatar ? props === null || props === void 0 ? void 0 : (_props$venue18 = props.venue) === null || _props$venue18 === void 0 ? void 0 : _props$venue18.avatar : "https://".concat("www.cocktayl.co", "/images/").concat( true ? ((_process$env$NEXT_PUB = "Cocktayl") === null || _process$env$NEXT_PUB === void 0 ? void 0 : (_process$env$NEXT_PUB2 = _process$env$NEXT_PUB.replace(" ", "")) === null || _process$env$NEXT_PUB2 === void 0 ? void 0 : _process$env$NEXT_PUB2.toLowerCase()) + "/" : 0, "image_placeholder_new.png"),
          width: 1200,
          height: 630,
          alt: "".concat(props === null || props === void 0 ? void 0 : (_props$venue19 = props.venue) === null || _props$venue19 === void 0 ? void 0 : _props$venue19.nickname).concat(tabType !== "about" ? " " + (0,formatHelpers/* capitalizeFirstLetter */.fm)(tabType) : "", " - ").concat("Cocktayl"),
          type: "image/png"
        }],
        siteName: "".concat("Cocktayl").concat(" - The Cocktail Bar You Need")
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "".concat(isMobileVersion ? "" : "flex flex-col h-[650px] self-stretch", " relative"),
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
        priority: true,
        objectFit: "fill",
        imgUrl: backgroundImage,
        quality: 1,
        alt: "".concat(props === null || props === void 0 ? void 0 : (_props$venue20 = props.venue) === null || _props$venue20 === void 0 ? void 0 : _props$venue20.nickname, " ").concat(category === config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST ? "Artist" : category === config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE ? "Venue" : category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP ? "Rooftop" : category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA ? "Spa" : category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? "Beach Club" : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY ? "Company" : category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES ? "Home" : category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO ? "Zoos" : category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL ? "Animals" : category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL ? "Parks" : category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? "Bar" : category === config/* Constants.categoryType.CATEGORY_EVENT */.gT.categoryType.CATEGORY_EVENT ? "Event" : "Festival")
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "bg-white/2 absolute bottom-0 left-0 right-0 top-0",
        style: {
          backdropFilter: "blur(40px)"
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(VenueProfileView_ProfileHeader, {
        photos: props !== null && props !== void 0 && (_props$venue21 = props.venue) !== null && _props$venue21 !== void 0 && _props$venue21.covers && (props === null || props === void 0 ? void 0 : (_props$venue22 = props.venue) === null || _props$venue22 === void 0 ? void 0 : (_props$venue22$covers = _props$venue22.covers) === null || _props$venue22$covers === void 0 ? void 0 : _props$venue22$covers.length) > 0 ? (props === null || props === void 0 ? void 0 : (_props$venue23 = props.venue) === null || _props$venue23 === void 0 ? void 0 : (_props$venue23$covers = _props$venue23.covers) === null || _props$venue23$covers === void 0 ? void 0 : _props$venue23$covers.map(function (i) {
          return {
            url: i.image
          };
        })) || [] : [{
          url: "Local:imagePlaceholder"
        }],
        activeIndex: activeIndex,
        setActiveIndex: setActiveIndex,
        items: itemsOther,
        venue: props.venue,
        isShowMenu: isShowMenu,
        onChangeIsShown: onChangeIsShown,
        onPressMenuItem: onPressMenuItem,
        style: {
          maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
          width: "100%",
          height: isMobileVersion ? 239 : 530,
          marginBottom: 120,
          alignSelf: "center"
        },
        isMobileVersion: isMobileVersion,
        category: category
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VenueInfoView, {
      style: {
        borderTopLeftRadius: isMobileVersion ? 25 : 120,
        borderTopRightRadius: isMobileVersion ? 25 : 120,
        marginTop: -120
      },
      item: props.venue,
      category: category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(VenueProfileView_ProfileBottomView, {
      style: {
        marginTop: isMobileVersion ? 0 : 20,
        maxWidth: config/* Constants.PROFILE_PAGE_WIDTH */.gT.PROFILE_PAGE_WIDTH,
        width: "100%",
        alignSelf: "center"
      },
      item: props.venue,
      category: category,
      isNested: true,
      initialTabType: tabType,
      subTabType: subTabType,
      venueEvents: venueEvents,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(modals_ProfileModalContainer, {
      ref: modalRef,
      item: props.venue,
      category: category,
      isMobileVersion: isMobileVersion
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(components_ProfileBottomMenuBar, {
      profile: props.venue,
      isMobileVersion: isMobileVersion,
      category: category,
      hideContact: true // hideContact={
      //   category != Constants.categoryType.CATEGORY_ZOO &&
      //   category != Constants.categoryType.CATEGORY_PARKFUL
      // }
      ,
      hideShare: isMobileVersion,
      onMorePress: function onMorePress() {
        setIsShowMenu(true);
      },
      onContactPress: function onContactPress() {
        return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
      },
      onSharePress: function onSharePress() {
        return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_SHARE */.gT.profileModalType.PROFILE_MODAL_SHARE);
      },
      renderMagicButton: function renderMagicButton() {
        return (// <TouchableOpacity onPress={() => setIsShowMenuMagic(true)}>
          //   <CImage
          //     source={Images.iconMenuMagic}
          //     width={60}
          //     height={60}
          //     layout="fixed"
          //   />
          // </TouchableOpacity>
          null
        );
      },
      renderButton: function renderButton() {
        if (category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: "\xA0"
          }); // } else if (
          //   category === Constants.categoryType.CATEGORY_ZOO ||
          //   category === Constants.categoryType.CATEGORY_PARKFUL
          // ) {
        } else if ((category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT) && props.venue.isBookingButton) {
          return isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: props.venue.bookWebsite || props.venue.contact.website,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flex: 1,
                width: "100%"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
                isHeading: true,
                buttonTitle: "Booking",
                icon: config/* Images.iconBooking */.rU.iconBooking,
                onPress: function onPress() {
                  return null;
                },
                filled: true,
                fontSize: isMobileVersion ? 12 : 16,
                iconStyle: isMobileVersion ? {
                  width: 16,
                  height: 16
                } : {
                  width: 20,
                  height: 20
                },
                style: isMobileVersion ? {
                  height: 32,
                  flex: 1
                } : {
                  height: 40,
                  width: 320
                },
                isMobileVersion: isMobileVersion
              })
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: props.venue.bookWebsite || props.venue.contact.website,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              target: "_blank",
              style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
                style: [VenueProfileView_styles.contactButton, isMobileVersion ? {
                  marginRight: 8,
                  height: 34,
                  width: "auto"
                } : {}],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
                  width: isMobileVersion ? 16 : 20,
                  height: isMobileVersion ? 16 : 20,
                  layout: "fixed",
                  objectFit: "cover",
                  source: config/* Images.iconBooking */.rU.iconBooking,
                  alt: "contact"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                  style: [VenueProfileView_styles.contactButtonText, category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? {
                    color: config/* Colors.black */.wL.black
                  } : {}, isMobileVersion ? {
                    fontSize: 12
                  } : {}, {
                    textTransform: "uppercase"
                  }],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    children: "Booking"
                  })
                })]
              })
            })
          });
        } else if (category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES) {
          var _props$venue24, _props$venue24$compan, _props$venue25, _props$venue25$compan, _props$venue26, _props$venue26$compan, _props$venue27, _props$venue27$compan;

          return isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: (0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$venue24 = props.venue) === null || _props$venue24 === void 0 ? void 0 : (_props$venue24$compan = _props$venue24.company) === null || _props$venue24$compan === void 0 ? void 0 : _props$venue24$compan.id, props === null || props === void 0 ? void 0 : (_props$venue25 = props.venue) === null || _props$venue25 === void 0 ? void 0 : (_props$venue25$compan = _props$venue25.company) === null || _props$venue25$compan === void 0 ? void 0 : _props$venue25$compan.nickname, null, config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY, "about"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              className: "w-full flex flex-1",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
                isHeading: true,
                buttonTitle: "Company Profile",
                onPress: function onPress() {},
                filled: true,
                fontSize: isMobileVersion ? 12 : 16,
                iconStyle: isMobileVersion ? {
                  width: 16,
                  height: 16
                } : {
                  width: 20,
                  height: 20
                },
                style: isMobileVersion ? {
                  height: 32,
                  flex: 1
                } : {
                  height: 40,
                  width: 320
                },
                isMobileVersion: isMobileVersion
              })
            })
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: (0,helpers_0/* generateURLSlug */.ZF)(props === null || props === void 0 ? void 0 : (_props$venue26 = props.venue) === null || _props$venue26 === void 0 ? void 0 : (_props$venue26$compan = _props$venue26.company) === null || _props$venue26$compan === void 0 ? void 0 : _props$venue26$compan.id, props === null || props === void 0 ? void 0 : (_props$venue27 = props.venue) === null || _props$venue27 === void 0 ? void 0 : (_props$venue27$compan = _props$venue27.company) === null || _props$venue27$compan === void 0 ? void 0 : _props$venue27$compan.nickname, null, config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY, "about"),
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((TouchableOpacity_default()), {
                onPress: function onPress() {},
                style: [VenueProfileView_styles.contactButton, isMobileVersion ? {
                  marginRight: 8,
                  height: 34,
                  width: "auto"
                } : {}],
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
                  style: [VenueProfileView_styles.contactButtonText, isMobileVersion ? {
                    fontSize: 12
                  } : {}, {
                    textTransform: "uppercase"
                  }, {
                    color: config/* Colors.white */.wL.white
                  }],
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                    children: "Company Profile"
                  })
                })
              })
            })
          });
        } else {
          return isMobileVersion ? /*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* IconizedButton */.YJ, {
            isHeading: true,
            buttonTitle: "Contact",
            icon: config/* Images.iconChatColor */.rU.iconChatColor,
            onPress: function onPress() {
              return modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
            },
            filled: true,
            fontSize: isMobileVersion ? 12 : 16,
            iconStyle: isMobileVersion ? {
              width: 16,
              height: 16
            } : {
              width: 20,
              height: 20
            },
            style: isMobileVersion ? {
              height: 32,
              flex: 1
            } : {
              height: 40,
              width: 320
            },
            isMobileVersion: isMobileVersion
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)((TouchableOpacity_default()), {
            onPress: function onPress() {
              modalRef.current.showModal(config/* Constants.profileModalType.PROFILE_MODAL_CONTACT */.gT.profileModalType.PROFILE_MODAL_CONTACT);
            },
            style: [VenueProfileView_styles.contactButton, isMobileVersion ? {
              marginRight: 8,
              height: 34,
              width: "auto"
            } : {}],
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(atoms/* CImage */.DW, {
              width: isMobileVersion ? 16 : 20,
              height: isMobileVersion ? 16 : 20,
              layout: "fixed",
              objectFit: "cover",
              source: category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL ? config/* Images.iconChatColor */.rU.iconChatColor : config/* Images.iconChat */.rU.iconChat,
              alt: "contact"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((Text_default()), {
              style: [VenueProfileView_styles.contactButtonText, isMobileVersion ? {
                fontSize: 12
              } : {}, {
                textTransform: "uppercase"
              }, category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || category === config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL || category === config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || category === config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || category === config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL ? {
                color: config/* Colors.black */.wL.black
              } : category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE ? {
                color: config/* Colors.white */.wL.white
              } : {}],
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                children: "Contact"
              })
            })]
          });
        }
      }
    }), isShowMenuMagic && /*#__PURE__*/(0,jsx_runtime.jsx)(PopupMenuListModal, {
      isVisible: isShowMenuMagic,
      onClose: function onClose() {
        setIsShowMenuMagic(false);
      },
      onPressItem: onPressMenuItem,
      items: itemsMagic,
      isMobileVersion: isMobileVersion,
      category: props.category
    })]
  });
};

var VenueProfileView_styles = StyleSheet_default().create({
  bottomContainer: {
    height: 90,
    alignSelf: "stretch",
    backgroundColor: config/* Colors.grayBackground */.wL.grayBackground,
    borderTopLeftRadius: 25,
    borderTopRightRadius: 25,
    marginBottom: 50,
    paddingHorizontal: 30,
    justifyContent: "center"
  },
  moreButton: {
    borderWidth: 1,
    borderColor: config/* Colors.spliterLine */.wL.spliterLine,
    borderRadius: 20,
    padding: 5
  },
  contactButton: VenueProfileView_objectSpread(VenueProfileView_objectSpread({}, (0,formatHelpers/* getClass */.ll)("btn-border2")), {}, (VenueProfileView_objectSpread2 = {
    borderRadius: 50,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 20,
    height: 40,
    flexDirection: "row"
  }, (0,defineProperty/* default */.Z)(VenueProfileView_objectSpread2, "alignItems", "center"), (0,defineProperty/* default */.Z)(VenueProfileView_objectSpread2, "marginRight", 15), (0,defineProperty/* default */.Z)(VenueProfileView_objectSpread2, "width", 320), VenueProfileView_objectSpread2)),
  contactButtonText: {
    fontFamily: config/* Fonts.primaryBold */.F3.primaryBold,
    fontSize: 16,
    lineHeight: 20,
    color: (0,formatHelpers/* getClass */.ll)("btn-text-contact"),
    textAlign: "center",
    marginLeft: 5
  }
});
/* harmony default export */ var views_VenueProfileView = (VenueProfileView);
;// CONCATENATED MODULE: ./src/modules/profile/venue/containers/VenueProfileViewContainer.js




var VenueProfileViewContainer = function VenueProfileViewContainer(props) {
  var id = props.id,
      profileId = props.profileId,
      venueEvents = props.venueEvents,
      tabType = props.tabType,
      subTabType = props.subTabType,
      category = props.category,
      item = props.item,
      lineup = props.lineup;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(views_VenueProfileView, {
    venue: item,
    lineup: lineup,
    tabType: tabType,
    subTabType: subTabType,
    venueEvents: venueEvents,
    category: category,
    isMobileVersion: props.isMobileVersion
  });
};

/* harmony default export */ var containers_VenueProfileViewContainer = (VenueProfileViewContainer);
;// CONCATENATED MODULE: ./src/modules/profile/index.js


function profile_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function profile_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? profile_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : profile_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // import UserProfileViewContainer from "./user/containers/UserProfileViewContainer";



var ProfileScreen = function ProfileScreen(props) {
  var renderContent = function renderContent() {
    var category = props.category;

    if (category == config/* Constants.categoryType.CATEGORY_ARTIST */.gT.categoryType.CATEGORY_ARTIST) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(containers_ArtistProfileViewContainer, profile_objectSpread({}, props));
    } else if (category == config/* Constants.categoryType.CATEGORY_VENUE */.gT.categoryType.CATEGORY_VENUE || category == config/* Constants.categoryType.CATEGORY_ROOFTOP */.gT.categoryType.CATEGORY_ROOFTOP || category == config/* Constants.categoryType.CATEGORY_SPA */.gT.categoryType.CATEGORY_SPA || category == config/* Constants.categoryType.CATEGORY_VENUE_BEACHFUL */.gT.categoryType.CATEGORY_VENUE_BEACHFUL || category == config/* Constants.categoryType.CATEGORY_VENUE_COCKTAIL */.gT.categoryType.CATEGORY_VENUE_COCKTAIL || category === config/* Constants.categoryType.CATEGORY_PREFAB_COMPANY */.gT.categoryType.CATEGORY_PREFAB_COMPANY || category === config/* Constants.categoryType.CATEGORY_PREFAB_HOMES */.gT.categoryType.CATEGORY_PREFAB_HOMES || category === config/* Constants.categoryType.CATEGORY_ANIMAL */.gT.categoryType.CATEGORY_ANIMAL || category === config/* Constants.categoryType.CATEGORY_ZOO */.gT.categoryType.CATEGORY_ZOO || category === config/* Constants.categoryType.CATEGORY_PARKFUL */.gT.categoryType.CATEGORY_PARKFUL || category === config/* Constants.categoryType.CATEGORY_CASINO */.gT.categoryType.CATEGORY_CASINO || category === config/* Constants.categoryType.CATEGORY_CASTLE */.gT.categoryType.CATEGORY_CASTLE || category === config/* Constants.categoryType.CATEGORY_RESORT */.gT.categoryType.CATEGORY_RESORT || category === config/* Constants.categoryType.CATEGORY_APARTHOTEL */.gT.categoryType.CATEGORY_APARTHOTEL) return /*#__PURE__*/(0,jsx_runtime.jsx)(containers_VenueProfileViewContainer, profile_objectSpread({}, props));else if (category == config/* Constants.categoryType.CATEGORY_USER */.gT.categoryType.CATEGORY_USER || category == config/* Constants.categoryType.CATEGORY_OTHER */.gT.categoryType.CATEGORY_OTHER) return null; // return <UserProfileViewContainer {...props} />;


    return /*#__PURE__*/(0,jsx_runtime.jsx)(containers_EventProfileViewContainer, profile_objectSpread({}, props));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "flex flex-col flex-1 bg-black",
    children: renderContent()
  });
};

/* harmony default export */ var profile = (ProfileScreen);

/***/ })

}]);